
import NavBar from '../components/NavBar'
import SideBar from '../components/SideBar'
import Container from '../components/Container'
import RightQuadrant from '../components/monitor-components/devicesMap/RightQuadrantNew'
import SearchHost from '../components/monitor-components/devicesMap/SearchHostNew'
import Notifications from '../components/Notifications'
import LeftQuadrant from '../components/monitor-components/devicesMap/LeftQuadrantNew'
import { useEffect, useState, useRef } from 'react'
import { useFetch } from '../hooks/useFetch'
import mapboxgl from 'mapbox-gl'
import MapBox from '../components/mapbox_gl'
import MapBoxWhite from '../components/mapbox-white'
import MapboxMapNew from '../components/monitor-components/devicesMap/MapboxMapNew'
import MapComponent from '../components/Map'
import LoadData from '../components/LoadData'
import Modal from 'react-modal';
import InfoMarker from '../components/monitor-components/devicesMap/InfoMarkerNew'
import '../components/styles/MapBox.css'
import '../components/monitor-components/devicesMap/MapStyles.css'
import arcos_list from '../components/arcos'
import data_switches from '../components/switches'
import ShowLayers from '../components/monitor-components/devicesMap/ShowLayersNew'
import { render } from '@testing-library/react'
import InternalError from '../components/generales/InternalError'
import ModalResponseEncuesta from '../components/encuestas-components/ModalResponseEncuesta'
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from '../components/generales/traduction'
import hosts from '../components/devices'
import Action from '../components/Action'
import ModalAddCorrelation from '../components/modals-monitoreo/ModalAddCorrelationDemo'
import ShowRelationDemo from '../components/ShowRelationDemo'
import PanelCorrelaciones from '../components/PanelCorrelaciones'
import PanelExcepcion from '../components/PanelExcepciones'
import PanelSidebar from '../components/PanelSidebar'
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    height: "85%",
    padding: "20px",
  },
};
const CreateCorrModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "85%",
    padding: "20px",
  },
};
const Monitoreo = ({ languaje, mode, token_item, userPermissions, dataGlobals, server, handleShowPopup, estados_list, estadoSelected, setEstadoSelected }) => {
  const dispId_default = -1
  const [internalError, setInternalError] = useState(false)
  const [capas, setCapas] = useState({})
  // console.log(dataGlobals)
  const global_longitud = dataGlobals.find(obj => obj.name === 'state_longitude')
  const global_latitude = dataGlobals.find(obj => obj.name === 'state_latitude')
  const global_zoom = dataGlobals.find(obj => obj.name === 'zoom')
  token_item = localStorage.getItem('access_token')
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [suveryId, setSuveryId] = useState(0)
  // console.log(ImportModalOpen)
  function closeImportModal() {
    setSuveryId(0)
    setImportModalOpen(false);
  }
  const [popups, setPopups] = useState([]);
  const [demoRelaciones, setDemoRelaciones] = useState([])
  const [demoExcepciones, setDemoExcepciones] = useState([])
  const [showPopups, setShowPopups] = useState(true);
  // const [ubicacion,setUbicacion]=useState({latitud:'20.01808757489169',longitud:'-101.21789252823293',groupid:0,dispId:11,templateId:0})
  const [ubicacion, setUbicacion] = useState({ latitud: global_latitude.value, longitud: global_longitud.value, groupid: 0, dispId: dispId_default, templateId: 0 })
  const [ubiActual, setUbiActual] = useState({ municipio: 'TODOS', groupid: 0, dispId: dispId_default, templateId: 0 })
  const [severityProblms, setSeverityProblms] = useState([((ubiActual.dispId == -1) ? "6" : "6")])
  const [metricaSelected, setMetricaSelected] = useState("")
  const [zoom, setZoom] = useState(11)
  const [latitudes, setLatitudes] = useState([])
  const [longitudes, setLongitudes] = useState([])
  const [locations, setLocations] = useState([])

  // ////console.log(ubicacion)

  const [markers, setMarkers] = useState([])
  const [markers1, setMarkers1] = useState([]);
  const [markers2, setMarkers2] = useState([]);
  const [switchesFO, setSwitchesFO] = useState([]);
  const [switchesMO, setSwitchesMO] = useState([]);
  const [switchesDownFO, setSwitchesDownFO] = useState([]);
  const [switchesDownMO, setSwitchesDownMO] = useState([]);
  // //////console.log(switchesFO,switchesFO,markers)
  const [markersWOR, setMarkersWOR] = useState([])
  const [markersUnknown, setMarkersUnknown] = useState([])
  const [lines, setLines] = useState([])
  const [downs, setDowns] = useState([])
  const [towers, setTowers] = useState([])
  const [rfid, setRfid] = useState([])
  const [lpr, setLpr] = useState([])
  const [switches, setSwitches] = useState([])
  const [exceptions, setExceptions] = useState([])
  //  console.log(exceptions)
  const [token, setToken] = useState("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY")
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [devices, setDevices] = useState({ data: [], loading: true, error: null });
  ////console.log(devices)
  const [dataTec, setDataTec] = useState({ data: [], loading: true, error: null })
  const [dataProblems, setDataProblems] = useState({ data: [], loading: true, error: null })
  const [dataProblemsError, setDataProblemsError] = useState({ data: [], loading: true, error: null })
  const [dataExceptions, setDataExceptions] = useState({ data: [], loading: true, error: null })
  const [dataExceptionsCity, setDataExceptionsCity] = useState({ data: [], loading: true, error: null })
  const [downs_list, setDownsList] = useState({ data: [], loading: true, error: null });
  const tower_list = useFetch('zabbix/layers/towers', '', token_item, 'GET', server)
  const dataAgencies = useFetch('cassia/exception_agencies', '', token_item, 'GET', server)
  const dataCriticalities = useFetch('cassia/criticalities', '', token_item, 'GET', server)
  const [rfid_list, setRfidList] = useState({ data: [], loading: true, error: null });
  const [rfidData, setRfidData] = useState({ map: {}, getSource: {}, popup: null });
  const [exceptData, setExceptData] = useState({})
  const [lpr_list, setLprList] = useState({ data: [], loading: true, error: null });
  const [lprData, setLprData] = useState({ map: {}, getSource: {}, popup: null });
  const [switch_list, setSwitchList] = useState({ data: [], loading: true, error: null });
  const [exceptions_list, setExceptionsList] = useState({ data: [], loading: true, error: null });
  const [mapAux, setmapAux] = useState({});
  const [rfidInterval, setRfidInterval] = useState(0)

  const [lprInterval, setLprInterval] = useState(0)

  const [renderCapas, setRenderCapas] = useState({ downs: false, markersWOR: true, markers: true, rfid: true, switches: true, lpr: true, towers: false, exceptions: false })
  const capasList = ['Downs', 'Conectados', 'Dispositivos', 'RFID', 'Switches/Ruteadores', 'LPR', 'Torres', 'Excepciones']

  const [renderMap, setRenderMap] = useState(false)
  const allTrue = Object.values(renderCapas).every(value => value === true);
  const [loaderMap, setLoaderMap] = useState(true)
  // const loaderMap=(ubicacion.dispId==-1)?downs_list.loading:devices.loading
  ////console.log('alltrue '+loaderMap)
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);

  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {



    setCreateCisModalOpen(false);
  }
  useEffect(() => {
    if (allTrue) {
      ////console.log('Todos los atributos están en true');
      // setLoaderMap(true)
      // setRenderMap(true)
    } else {
      ////console.log('Al menos uno de los atributos está en false');
      ////console.log(renderCapas)
    }
  }, [renderCapas])
  useEffect(() => {
    // console.log("actualiza markers")
    // console.log([markers1,markers2,switchesDownFO,switchesDownMO])

    // if(ubicacion.templateId!=0){
    setMarkers([markers1, markers2, switchesDownFO, switchesDownMO])
    // }

  }, [markers1, markers2])
  useEffect(() => {
    //   console.log("actualiza switches tipe")
    //  console.log(switchesFO,switchesMO)
    if (switchesFO.length > 0 || switchesMO.length > 0) {
      setSwitches([switchesFO, switchesMO, switchesDownFO, switchesDownMO])
    }

  }, [switchesFO, switchesMO])
  useEffect(() => {
    // //////console.log(renderCapas.markersWOR)
    if (markersWOR.length !== 0) {
      //////console.log('El proceso de markersWOR ha terminado',markersWOR.length);
      setRenderCapas(prevState => ({
        ...prevState,
        markersWOR: true
      }));
    }


  }, [markersWOR]);
  useEffect(() => {
    // //////console.log(renderCapas.markersWOR)
    if (markersUnknown.length !== 0) {
      //////console.log('El proceso de markersWOR ha terminado',markersWOR.length);
      setRenderCapas(prevState => ({
        ...prevState,
        markersWOR: true
      }));
    }


  }, [markersUnknown]);
  //  useEffect(() => {
  //   // //////console.log(renderCapas.markersWOR)
  //   if(markersWOR.length!==0){
  //     //////console.log('El proceso de markersWOR ha terminado',markersWOR.length);
  //     setRenderCapas(prevState => ({
  //       ...prevState,
  //       markersWOR: true 
  //     }));
  //   }


  // }, [markersWOR]); 

  useEffect(() => {
    if (exceptions.length !== 0) {

      //////console.log('El proceso de markersWOR ha terminado',markersWOR.length);
      setRenderCapas(prevState => ({
        ...prevState,
        exceptions: true
      }));
    }
  }, [exceptions]);
  useEffect(() => {
    ////console.log(renderCapas.towers)
    ////console.log("++++++++++++++++++++++++++++++++++++++++++++++++++")
    ////console.log(towers)
    if (towers.length !== 0) {
      //////console.log('El proceso de markersWOR ha terminado',markersWOR.length);
      setRenderCapas(prevState => ({
        ...prevState,
        towers: true
      }));
    }


  }, [towers]);
  useEffect(() => {
    // console.log('El proceso de downs ha terminado');
    // console.log(downs)
    setRenderCapas(prevState => ({
      ...prevState,
      downs: true
    }));
  }, [downs]);
  useEffect(() => {
    if (rfid.length > 0) {
      //////console.log('El proceso de rfid ha terminado');
      // //////console.log(rfid)
      setRenderCapas(prevState => ({
        ...prevState,
        rfid: true
      }));
    }

  }, [rfid]);
  useEffect(() => {
    if (lpr.length > 0) {
      ////console.log('El proceso de lpr ha terminado');
      // //////console.log(rfid)
      setRenderCapas(prevState => ({
        ...prevState,
        lpr: true
      }));
    }

  }, [lpr]);
  useEffect(() => {
    // console.log("proceso switches ************************" )
    // console.log(switchesFO.length+" | "+switchesMO.length)
    if (switchesFO.length > 0 || switchesMO.length > 0) {
      // console.log('El proceso de switches ha terminado');
      // console.log(switches)
      setRenderCapas(prevState => ({
        ...prevState,
        switches: true
      }));
    }

  }, [switches]);
  // useEffect(() => {
  // console.log("proceso switches ,,markers2************************" )
  // console.log(switchesFO.length+" | "+switchesMO.length)
  //   // if(switchesFO.length>0  || switchesMO.length>0){
  //     console.log('El proceso de switches ha terminado');
  //     console.log(switches)
  //     setRenderCapas(prevState => ({
  //       ...prevState,
  //       switches: true 
  //     }));
  //   // }

  // }, [switchesDownFO,switchesDownMO,markers1,markers2]);
  useEffect(() => {
    //////console.log('El proceso de markers ha terminado',markers);
    setRenderCapas(prevState => ({
      ...prevState,
      markers: true
    }));
  }, [markers]);
  useEffect(() => {
    setInternalError(false)
    // search_problems()
    // search_downs()
    // search_exceptions()

  }, [])

  useEffect(() => {
    if (downs_list.data.length !== 0) {

      // search_exceptions()
      objeto_downs(downs_list)
    }
  }, [downs_list.data])

  useEffect(() => {
    if (rfid_list.data.length !== 0) {
      objeto_rfid(rfid_list.data)
      // setTimeout(search_rfid, 10000); 
    }

  }, [rfid_list.data])
  useEffect(() => {
    if (rfid.length !== 0) {
      // //////console.log('actualizo rfid')
      // //////console.log(rfid)
      actualizar_layer_rfid(rfid)
    }

  }, [rfid])
  useEffect(() => {
    ////console.log("lpr list --------------------------------------")
    ////console.log(lpr_list)
    if (lpr_list.data.length !== 0) {
      objeto_lpr(lpr_list.data)
    }

  }, [lpr_list.data])
  useEffect(() => {
    if (lpr.length !== 0) {
      //////console.log('actualizo lpr')
      //////console.log(lpr)
      actualizar_layer_lpr(lpr)
    }

  }, [lpr])
  useEffect(() => {
    if (tower_list.data.length !== 0) {
      ////console.log("pinta")
      objeto_towers(tower_list.data.data)
    }
  }, [tower_list.data])
  useEffect(() => {
    if (switch_list.data.length !== 0) {
      //////console.log(switch_list.data)

      objeto_switches(switch_list.data)
    }
  }, [switch_list.data])

  useEffect(() => {
    if (exceptions_list.data.length !== 0) {
      objeto_exceptions(exceptions_list.data)
      // search_downs()
    }
  }, [exceptions_list.data])
  function objeto_exceptions(exceptions_list) {
    // if(downs_list.data.length!=0){
    exceptions_list.map((excpt, index, array) => {

      if (excpt.latitude.replace(",", ".") >= -90 && excpt.latitude.replace(",", ".") <= 90 && (excpt.closed_at == null || excpt.closed_at == "")) {

        // if(excpt.exception_agency_id==0){
        // console.log(excpt)
        //   console.log("--------------------------------------------------------------")
        // }
        const reset_info = (downs_list.data.metrics == undefined) ? [] : downs_list.data.metrics.find(obj => obj.hostid === excpt.hostid)
        // const reset_info2=devices.data.subgroup_info.find(obj => obj.hostid === excpt.hostid)
        // console.log(reset_info)
        // console.log(reset_info2)
        const levels_colors = ['#c1c1c1b0', '#00ff70', '#ffee00', '#ee5c08']
        // console.log(excpt)
        // if(excpt.status==2){
        //   console.log(excpt)
        //   console.log("--------------------------------------------------------------")
        // }
        setExceptions(exceptions => [...exceptions, {
          type: 'Feature',
          properties: {
            Name: excpt.hostname,
            latitude: excpt.latitude.replace(",", "."),
            longitude: excpt.longitude.replace(",", "."),
            end_lat: excpt.latitude.replace(",", "."),
            end_lon: excpt.longitude.replace(",", "."),
            hostidC: excpt.hostid,
            hostidP: '',
            name_hostC: excpt.hostname,
            name_hostipC: excpt.ip,
            exception_agency_id: excpt.exception_agency_id,
            description: excpt.description,
            descripcion: excpt.description,
            hostid: excpt.hostid,
            type: excpt.status,
            ip: excpt.ip,
            name: excpt.name,
            aux: 'aux',
            color_alineacion2: (ubicacion.dispId == 26 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? '#757575af' : ((reset_info.metrics[0].value > 23) ? '#00ff70' : (reset_info.metrics[0].value < 20) ? '#ee5c08' : '#ffee00')) : '#ff0000',
            color_alineacion: ((ubicacion.dispId == 26 || ubicacion.dispId == 4 || ubicacion.dispId == 8) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? levels_colors[0] : levels_colors[reset_info.metrics[0].level]) : '#ff0000',
            metrics: ((ubicacion.dispId == 26 || ubicacion.dispId == 4 || ubicacion.dispId == 8) && reset_info != undefined) ? reset_info.metrics : [],
            level: ((ubicacion.dispId == 26 || ubicacion.dispId == 4 || ubicacion.dispId == 8) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? 0 : (reset_info.metrics[0].level == undefined ? -1 : reset_info.metrics[0].level)) : -1,
            status: (ubicacion.dispId == 26 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? 0 : ((reset_info.metrics[0].value > 23) ? 1 : (reset_info.metrics[0].value < 20) ? 3 : 2)) : -1
          },
          geometry: {
            type: 'Point',
            coordinates: [excpt.longitude.replace(",", "."), excpt.latitude.replace(",", ".")],
          },
        }])
        // console.log(exceptions)
      } else {
        ////////console.log(host)
      }
      // }

    }
    )
    // }else{
    //   // objeto_exceptions(exceptions_list)
    // }
  }
  function objeto_towers(aps) {
    // console.log("*************** APS ***********")
    // console.log(aps)
    if (aps.length != 0) {
      aps.map((host, index, array) => {
        if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {

          setTowers(towers => [...towers, {
            type: 'Feature',
            properties: {
              Name: host.name,
              latitude: host.latitude,
              longitude: host.longitude,

            },
            geometry: {
              type: 'Point',
              coordinates: [host.longitude.replace(",", "."), host.latitude.replace(",", ".")],
            },
          }])

        } else {
          ////////console.log(host)
        }
      }
      )
    } else {
      setRenderCapas(prevState => ({
        ...prevState,
        towers: true
      }));
    }
  }

  /****************************************************************** */
  function objeto_downs(downs_list) {
    // console.log("***************************************************objeto_downs")
    // console.log(downs_list.data.metrics2)
    if (!downs_list.data || !downs_list.data.downs) return;
    let flag_ubicacion = false
    downs_list.data.downs.map((host, index, array) => {

      if (ubicacion.dispId == -1 && !flag_ubicacion) {
        if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {
          setUbicacion({ latitud: host.latitude, longitud: host.longitude, groupid: ubicacion.groupid, dispId: ubicacion.dispId, templateId: ubicacion.templateId })
          // console.log(host);
          flag_ubicacion = true
        }
      }
      if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {
        // console.log(downs_list.data)

        const reset_info = (downs_list.data.metrics == undefined) ? [] : downs_list.data.metrics.find(obj => obj.hostid === host.hostid)
        // console.log("***************************reset_info Downs",host.hostid)
        // console.log(reset_info)
        // const hostidC = devices.data.hosts.find(obj => obj.hostid === host.hostid)
        // console.log(host.hostid)
        // console.log(exceptions_list.data.some(item => item.hostid === host.hostid))
        // if(host.hostid=='35754'){
        //   console.log('-----------------------------------------------')
        // }
        const levels_colors = ['#c1c1c1b0', '#00ff70', '#ffee00', '#ee5c08']
        //*******************Excepcones */

        // const is_exception=exceptions_list.data.some(item => item.hostid === host.hostid)
        // console.log(host.hostid)
        // console.log(is_exception)
        // if(is_exception){
        //   // console.log('-----------------------------------------------')
        //   const feature = exceptions.find(item => item.properties.hostid === host.hostid);
        //     console.log(feature)
        //     console.log(host.origen)
        //     if (feature) {
        //       feature.properties.type = host.origen;  // Cambiar el type al valor que quieras
        //       console.log('Modificado:', feature);
        //     } 
        // }
        // if(!is_exception){

        setDowns(downs => [...downs, {
          type: 'Feature',
          properties: {
            Name: host.name,
            latitude: host.latitude.replace(",", "."),
            longitude: host.longitude.replace(",", "."),
            hostid: host.hostid,
            descripcion: host.description,
            value: host.value,
            hostidC: host.hostid,
            hostidP: '',
            end_lat: host.latitude.replace(",", "."),
            end_lon: host.longitude.replace(",", "."),
            name_hostC: host.name,
            name_hostipC: host.ip,
            origen: host.origen,
            color_alineacion2: (ubicacion.dispId == 26 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? '#757575af' : ((reset_info.metrics[0].value > 23) ? '#00ff70' : (reset_info.metrics[0].value < 20) ? '#ee5c08' : '#ffee00')) : '#ff0000',
            color_alineacion: ((host.device_id != -1) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? levels_colors[0] : levels_colors[reset_info.metrics[0].level]) : '#ff0000',

            metrics: ((host.device_id != -1) && reset_info != undefined) ? reset_info.metrics : [],
            level: ((host.device_id != -1) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? 0 : (reset_info.metrics[0].level == undefined ? -1 : reset_info.metrics[0].level)) : -1,
            status: (ubicacion.dispId == 26 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? 0 : ((reset_info.metrics[0].value > 23) ? 1 : (reset_info.metrics[0].value < 20) ? 3 : 2)) : -1
          },
          geometry: {
            type: 'Point',
            coordinates: [host.longitude.replace(",", "."), host.latitude.replace(",", ".")],
          },
        }])
        // }


      } else {
        ////////console.log(host)
      }
    }
    )
  }
  /****************************************************************** */
  function objeto_rfid(rfid_list) {
    // //////console.log("objeto rfid")
    // //////console.log(rfid_list)
    setRfid([])
    rfid_list.map((host, index, array) => {

      // if(host.length!==0 && host.Latitud>=-90 && host.Latitud<=90 ){

      //   setRfid(rfid=>[...rfid,{
      //     type: 'Feature',
      //     properties:{
      //       latitude: host.Latitud,
      //       longitude: host.Longitud,
      //       lecturas:host.Lecturas
      //     },
      //     geometry: {
      //       type: 'Point',
      //       coordinates: [host.Longitud, host.Latitud],
      //     },
      //   }])

      // }else{
      //   ////////console.log(host)
      // }
      if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {

        setRfid(rfid => [...rfid, {
          type: 'Feature',
          properties: {
            latitude: host.latitude,
            longitude: host.longitude,
            lecturas: host.Lecturas,
            severidad: host.max_severity
          },
          geometry: {
            type: 'Point',
            coordinates: [host.longitude.replace(",", "."), host.latitude.replace(",", ".")],
          },
        }])

      } else {
        // //////console.log(host)
      }
    }
    )
    // setTimeout(search_rfid, 10000); 
  }
  /****************************************************************** */
  function objeto_lpr(lpr_list) {
    // console.log("objeto lpr ---------------------------------------------------------")
    // console.log(lpr_list)
    setLpr([])
    lpr_list.map((host, index, array) => {

      if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {

        setLpr(lpr => [...lpr, {
          type: 'Feature',
          properties: {
            latitude: host.latitude,
            longitude: host.longitude,
            lecturas: host.Lecturas,
            severidad: host.max_severity,
            activo: host.activo,
            hostname: host.hostname
          },
          geometry: {
            type: 'Point',
            coordinates: [host.longitude.replace(",", "."), host.latitude.replace(",", ".")],
          },
        }])

      } else {
        // //////console.log(host)
      }
    }
    )
    // setTimeout(search_rfid, 10000); 
  }
  /****************************************************************** */

  function search_problems() {
    // console.log("#########################################################3")

    setInternalError(false)
    search_count_exceptions()
    search_count_exceptions_city()
    search_problems_errors()
    setDataProblems({ data: dataProblems.data, loading: true, error: "" })
    const fetchData = async () => {
      try {
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación
        const devicefilter = (ubicacion.dispId !== 0 && ubicacion.dispId !== -1) ? '?tech_host_type=' + ubicacion.dispId : ''
        const subtypefilter = ubicacion.templateId !== 0 ? 'subtype=' + ubicacion.templateId : ''
        const severityfilter = (ubiActual.dispId == -1) ? 'severities=6' : (severityProblms.length > 0 ? 'severities=' + severityProblms.join(', ') : '')
        let andAux = (devicefilter !== '') ? '&' : '?'
        andAux = (subtypefilter !== '') ? andAux : ''

        // console.log(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter)
        // const response = await fetch(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter, {     
        const response = await fetch(server.url + '/api/v1/zabbix/problems/' + ubicacion.groupid + '' + devicefilter + andAux + subtypefilter + (((ubicacion.dispId == 0 && ubicacion.templateId == 0) || ubicacion.dispId == -1) ? '?' : '&') + severityfilter, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          // console.log(response_data)
          setDataProblems({ data: response_data.data, loading: false, error: "" })


        } else {
          const response_data = await response.json();
          // console.log(response_data)
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setInternalError(true)
        setDataProblems({ data: [], loading: dataProblems.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }

  function search_problems_errors() {
    // console.log("*************************************************")

    setInternalError(false)
    setDataProblemsError({ data: dataProblemsError.data, loading: true, error: "" })
    const fetchData = async () => {
      try {
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación
        const devicefilter = (ubicacion.dispId !== 0 && ubicacion.dispId !== -1) ? '?tech_host_type=' + ubicacion.dispId : ''
        const subtypefilter = ubicacion.templateId !== 0 ? 'subtype=' + ubicacion.templateId : ''
        const severityfilter = (ubiActual.dispId == -1) ? 'severities=6' : (severityProblms.length > 0 ? 'severities=' + severityProblms.join(', ') : '')
        let andAux = (devicefilter !== '') ? '&' : '?'
        andAux = (subtypefilter !== '') ? andAux : ''

        // console.log(server.url+'/api/v1/zabbix/problems_errors/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter)
        // const response = await fetch(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter, {     
        const response = await fetch(server.url + '/api/v1/zabbix/problems_errors/' + ubicacion.groupid + '' + devicefilter + andAux + subtypefilter + (((ubicacion.dispId == 0 && ubicacion.templateId == 0) || ubicacion.dispId == -1) ? '?' : '&') + severityfilter, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          // console.log(response_data)
          setDataProblemsError({ data: response_data.data, loading: false, error: "" })


        } else {
          const response_data = await response.json();
          // console.log(response_data)
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setInternalError(true)
        setDataProblemsError({ data: [], loading: dataProblemsError.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }
  function search_count_exceptions() {

    setDataExceptions({ data: dataExceptions.data, loading: true, error: "" })
    const fetchData = async () => {
      try {
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación


        // console.log(server.url+'/api/v1/cassia/exceptions/count/0?dispId='+ubicacion.dispId)
        // const response = await fetch(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter, {     
        const response = await fetch(server.url + '/api/v1/cassia/exceptions/count/0?dispId=' + ubicacion.dispId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          // console.log(response_data)
          // console.log("#########################################################3")
          setDataExceptions({ data: response_data.data, loading: false, error: "" })


        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setDataExceptions({ data: [], loading: dataExceptions.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }

  function search_count_exceptions_city() {

    setDataExceptionsCity({ data: dataExceptionsCity.data, loading: true, error: "" })
    const fetchData = async () => {
      try {
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación


        // console.log(server.url+'/api/v1/cassia/exceptions/count/'+ubicacion.groupid+'?dispId='+ubicacion.dispId)
        // const response = await fetch(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter, {     
        const response = await fetch(server.url + '/api/v1/cassia/exceptions/count/' + ubicacion.groupid + '?dispId=' + ubicacion.dispId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          // console.log(response_data)
          // console.log("#########################################################3")
          setDataExceptionsCity({ data: response_data.data, loading: false, error: "" })


        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setDataExceptionsCity({ data: [], loading: dataExceptionsCity.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }




  // useEffect(()=>{


  //   // search_downs()
  // },[])
  function search_switches() {
    setSwitches([])
    setSwitchesFO([])
    setSwitchesMO([])
    // //////console.log("borra rfid")
    setSwitchList({ data: [], loading: true, error: switch_list.error })
    const fetchData = async () => {
      try {
        // //////console.log(server.url+'/api/v1/zabbix/layers/switches_connectivity')
        //  const response = await fetch(server.url+'/api/v1/zabbix/layers/switches_connectivity/'+ubicacion.groupid, {  
        const response = await fetch(server.url + '/api/v1/zabbix/hosts/0?dispId=12&subtype_id=Interface Bridge-Aggregation_: Bits', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          setSwitchList({ data: response_data.data, loading: false, error: switch_list.error })
          // setSwitchList({data:data_switches,loading:false,error:'rfid_list.error'})
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setSwitchList({ data: switch_list.data, loading: switch_list.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
    // setSwitchList({data:data_switches,loading:false,error:'rfid_list.error'})
  }
  function search_exceptions() {
    // //console.log(downs_list)
    setExceptions([])
    // setLoaderMap(true)
    // //////console.log()
    // //////console.log("borra rfid")
    setExceptionsList({ data: [], loading: true, error: exceptions_list.error })
    const fetchData = async () => {
      try {
        // console.log(server.url+'/api/v1/cassia/exceptions/count/'+ubicacion.groupid+'?dispId='+ubicacion.dispId)
        // const response = await fetch(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+(((ubicacion.dispId==0 && ubicacion.templateId==0) || ubicacion.dispId==-1)?'?':'&')+severityfilter, {     
        const response = await fetch(server.url + '/api/v1/cassia/exceptions/' + ubicacion.groupid + '?dispId=' + ubicacion.dispId, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        //////console.log(response)
        if (response.ok) {
          const response_data = await response.json();
          // setLoaderMap(false)
          if (response_data.data.length === 0) {
            //console.log("sin excepciones")
            setRenderCapas(prevState => ({
              ...prevState,
              exceptions: true
            }));
          } else {
            //console.log("con excepciones")
            setExceptionsList({ data: response_data.data, loading: false, error: exceptions_list.error })
          }
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setRenderCapas(prevState => ({
          ...prevState,
          exceptions: true
        }));
        setExceptionsList({ data: exceptions_list.data, loading: exceptions_list.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
    // setSwitchList({data:data_switches,loading:false,error:'rfid_list.error'})
  }
  function search_rfid() {
    setRfid([])
    // //////console.log()
    // //////console.log("borra rfid")
    setRfidList({ data: [], loading: true, error: rfid_list.error })
    const fetchData = async () => {
      try {
        //////console.log(server.url+'/api/v1/zabbix/layers/carreteros/'+ubicacion.groupid)
        const response = await fetch(server.url + '/api/v1/zabbix/layers/carreteros/' + ubicacion.groupid, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          // //////console.log(response_data.data)
          // //////console.log("arcos")
          // //////console.log(arcos_list)
          setRfidList({ data: response_data.data, loading: false, error: rfid_list.error })
          // setRfidList({data:arcos_list,loading:false,error:rfid_list.error})

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setRfidList({ data: rfid_list.data, loading: rfid_list.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }
  function search_lpr() {
    setLpr([])
    // //////console.log()
    // //////console.log("borra rfid")
    setLprList({ data: [], loading: true, error: lpr_list.error })
    const fetchData = async () => {
      try {
        ////console.log(server.url+'/api/v1/zabbix/layers/lpr/'+ubicacion.groupid)
        const response = await fetch(server.url + '/api/v1/zabbix/layers/lpr/' + ubicacion.groupid, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        ////console.log(response)
        if (response.ok) {
          const response_data = await response.json();
          ////console.log(response_data)
          ////console.log("response lpr-----------------------------------------")
          // //////console.log(arcos_list)
          setLprList({ data: response_data.data, loading: false, error: lpr_list.error })
          // setRfidList({data:arcos_list,loading:false,error:rfid_list.error})

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setLprList({ data: lpr_list.data, loading: lpr_list.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }
  function search_devices() {
    setExceptions([])

    setInternalError(false)
    setRenderMap(false)
    setRenderCapas(prevState => ({
      ...prevState,
      downs: false,
      markersWOR: (ubicacion.dispId !== -1) ? false : true,
      markers: (ubicacion.templateId !== 0) ? false : true,
      rfid: (ubicacion.dispId === 9) ? false : true,
      lpr: (ubicacion.dispId === 1) ? false : true,
      switches: (ubicacion.dispId === 12 || ubicacion.dispId === 5) ? false : true,
      towers: true,
      exceptions: false
    }));
    // //////console.log("search device ",rfidInterval)
    if (rfidInterval !== 0) {
      clearInterval(rfidInterval);
      setRfid([])
    }
    if (lprInterval !== 0) {
      clearInterval(lprInterval);
      setLpr([])
    }

    setMarkers([])
    setMarkers1([])
    setMarkers2([])
    setMarkersWOR([])
    setMarkersUnknown([])
    setLines([])
    setSwitches([])
    setLpr([])
    setLocations([])
    setRfid([])
    // setExceptions([])
    setLoaderMap(true)
    setDevices({ data: devices.data, loading: true, error: '' })


    const fetchData = async () => {
      try {
        ////console.log(`Bearer ${token_item}`)
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación
        // const response = await fetch(server.url+'/api/v1/zabbix/db/hosts/relations/'+ubicacion.groupid, {
        const devicefilter = ubicacion.dispId !== 0 ? '?dispId=' + ubicacion.dispId : ''
        const subtypefilter = ubicacion.templateId !== 0 ? 'subtype_id=' + ubicacion.templateId : ''
        let andAux = (devicefilter !== '') ? '&' : '?'
        andAux = (subtypefilter !== '') ? andAux : ''
        //console.log(server.url+'/api/v1/zabbix/hosts/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter)
        const response = await fetch(server.url + '/api/v1/zabbix/hosts/' + ubicacion.groupid + '' + devicefilter + andAux + subtypefilter, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });

        if (response.ok) {
          const response_data = await response.json();
          setDevices({ data: response_data.data, loading: false, error: devices.error })
          setLoaderMap(false)
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setDevices({ data: devices.data, loading: devices.loading, error: error })
        console.error(error);
      }
    };
    fetchData();
  }
  useEffect(() => {
    ////////console.log("entra devices")
    if (devices.data.length != 0) {
      // search_downs()
      // //////console.log("*************************************  UP  ************************************")
      // //////console.log(devices.data.hosts.length)
      // //////console.log("con severidad: ",devices.data.problems_by_severity)
      setLatitudes([])
      setLongitudes([])
      if (devices.data.hosts.length != 0) {
        objeto_markers_wor(devices.data)

      } else {
        setRenderCapas(prevState => ({
          ...prevState,
          markersWOR: true
        }));
      }
      if (devices.data.host_unknown.length != 0) {
        objeto_markers_unknown(devices.data)

      }
      if (devices.data.relations.length != 0) {
        ////////console.log("entra a relaciones!!!!!!!!")
        objeto_relaciones(devices.data)
      }
      if (devices.data.subgroup_info.length != 0) {
        objeto_subgroup_info(devices.data)
      } else if (devices.data.correlations.length != 0) {
        objeto_subgroup_info(devices.data)
      } else if (devices.data.hosts.length != 0 && ubicacion.dispId === 2) {
        objeto_antenas(devices.data)
      }


    }

  }, [devices.data])
  function search_downs() {
    setInternalError(false)
    setDowns([])
    // search_exceptions()
    // //////console.log("use downs",ubicacion)
    const odd = (ubicacion.dispId === -1) ? '/origen' : ''
    if (ubicacion.dispId === -1) {
      setLoaderMap(true)
      setMarkers([])
      setMarkers1([])
      setMarkers2([])
      setMarkersWOR([])
      setMarkersUnknown([])
      setLines([])
      setSwitches([])
      setLpr([])
      setLocations([])
      // setExceptions([])
      setRenderCapas(prevState => ({
        ...prevState,
        downs: false,
        markersWOR: (ubicacion.dispId !== -1) ? false : true,
        markers: (ubicacion.templateId !== 0) ? false : true,
        rfid: (ubicacion.dispId === 9) ? false : true,
        lpr: (ubicacion.dispId === 1) ? false : true,
        switches: (ubicacion.dispId !== -1) ? false : true,//(ubicacion.dispId===12 || ubicacion.dispId===5 || ubicacion.dispId===11  || ubicacion.dispId===31 || ubicacion.dispId===0 || ubicacion.dispId==23 || ubicacion.dispId==14)?false:true,
        towers: true,
        // exceptions:false
      }));
    }
    setDownsList({ data: downs_list.data, loading: true, error: downs_list.error })
    const fetchData = async () => {
      try {
        let body = (ubicacion.dispId === 0 || ubicacion.dispId === -1) ? '' : '?dispId=' + ubicacion.dispId
        const response = await fetch(server.url + '/api/v1/zabbix/layers/downs' + odd + '/' + ubicacion.groupid + '' + body, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          setDownsList({ data: response_data.data, loading: false, error: downs_list.error })
          search_exceptions()
          if (ubicacion.dispId === -1) {
            setLoaderMap(false)
          }
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setInternalError(true)
        setDownsList({ data: downs_list.data, loading: downs_list.loading, error: error })
        //console.error(error);
        setLoaderMap(false)
      }
    };
    fetchData();
  }
  function objeto_subgroup_info(devices_data) {
    devices_data.correlations.map((host, index, array) => {
      // }

      if (true) {
        // console.log('es ruteador')
        if (host.length !== 0 && host.lat_padre.replace(",", ".") >= -90 && host.lat_padre.replace(",", ".") <= 90 && host.lat_hijo.replace(",", ".") >= -90 && host.lat_hijo.replace(",", ".") <= 90) {


          // console.log("indice"+index+" | tipo:"+host.medio_id)
          // console.log(hostSub   )
          let alineacion = 0
          let severity = 0


          let colorSG = '#00ff70'


          if (host.severity == 1) {
            colorSG = '#ffee00'
            // severity=1
          } else if (host.severity == 2) {
            colorSG = '#ee9d08'
            // severity=2
          } else if (host.severity == 3) {
            colorSG = '#ee5c08'
            // severity=3
          } else if (host.severity == 4) {
            colorSG = '#ee0808'
            // severity=4
          }
          //azul #4fb7f3
          // verde "#1fee08"

          if (host.medio_id == 1 && (host.valor_status_enlace == 1 || host.valor_status_enlace == null)) {
            setMarkers1(markers1 => [...markers1, {
              type: 'Feature',
              properties: {
                correlarionid: host.id,
                init_lat: host.lat_padre.replace(",", "."),
                init_lon: host.lon_padre.replace(",", "."),
                end_lat: host.lat_hijo.replace(",", "."),
                end_lon: host.lon_hijo.replace(",", "."),
                Metric: host,
                connectivity: host.valor_status_enlace,
                //name:host.name,
                hostidC: host.hostidC,
                hostidP: host.host_padre_id,
                // BitsSent: host.BitsSent,
                color_alineacion: colorSG,
                severity: (host.valor_status_enlace == 0) ? host.valor_status_enlace : host.severity,
                type_connection: host.medio_id,
                // severity:Math.floor(Math.random() * 4) + 1,
                metrica: metricaSelected,
              },
              geometry: {
                type: 'LineString',
                coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              },
            }])
          } else if (host.medio_id == 1 && host.valor_status_enlace == 0) {
            setSwitchesDownFO(switchesDownFO => [...switchesDownFO, {
              type: 'Feature',
              properties: {
                correlarionid: host.id,
                init_lat: host.lat_padre.replace(",", "."),
                init_lon: host.lon_padre.replace(",", "."),
                end_lat: host.lat_hijo.replace(",", "."),
                end_lon: host.lon_hijo.replace(",", "."),
                Metric: host,
                name: host.name,
                hostidC: host.hostidC,
                hostidP: host.host_padre_id,
                BitsSent: host.BitsSent,
                color_alineacion: colorSG,
                severity: 0,
                connectivity: host.valor_status_enlace,
                type_connection: host.medio_id,
                // severity:Math.floor(Math.random() * 4) + 1,
                metrica: metricaSelected,
              },
              geometry: {
                type: 'LineString',
                coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              },
            }])
          } else if (host.medio_id == 2 && (host.valor_status_enlace == 1 || host.valor_status_enlace == null)) {
            setMarkers2(markers2 => [...markers2, {
              type: 'Feature',
              properties: {
                correlarionid: host.id,
                init_lat: host.lat_padre.replace(",", "."),
                init_lon: host.lon_padre.replace(",", "."),
                end_lat: host.lat_hijo.replace(",", "."),
                end_lon: host.lon_hijo.replace(",", "."),
                Metric: host,
                name: host.name,
                hostidC: host.hostidC,
                hostidP: host.host_padre_id,
                BitsSent: host.BitsSent,
                color_alineacion: colorSG,
                connectivity: host.valor_status_enlace,
                severity: (host.valor_status_enlace == 0) ? host.valor_status_enlace : host.severity,
                type_connection: host.medio_id,
                // severity:Math.floor(Math.random() * 4) + 1,
                metrica: metricaSelected,
              },
              geometry: {
                type: 'LineString',
                coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              },
            }])
          } else if (host.medio_id == 2 && host.valor_status_enlace == 0) {
            setSwitchesDownMO(switchesDownMO => [...switchesDownMO, {
              type: 'Feature',
              properties: {
                correlarionid: host.id,
                init_lat: host.lat_padre.replace(",", "."),
                init_lon: host.lon_padre.replace(",", "."),
                end_lat: host.lat_hijo.replace(",", "."),
                end_lon: host.lon_hijo.replace(",", "."),
                Metric: host,
                name: host.name,
                hostidC: host.hostidC,
                hostidP: host.host_padre_id,
                BitsSent: host.BitsSent,
                color_alineacion: colorSG,
                severity: 0,
                connectivity: host.valor_status_enlace,
                type_connection: host.medio_id,
                // severity:Math.floor(Math.random() * 4) + 1,
                metrica: metricaSelected,
              },
              geometry: {
                type: 'LineString',
                coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              },
            }])
          }

          // setMarkers([markers1,markers2])
          //   //////console.log(markers1)
          //  //////console.log(markers2) 
          /****************************************************************** */

        }
      } else {
        if (ubiActual.dispId != 26 && ubiActual.dispId != 4 && ubiActual.dispId != 8) {
          if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {
            let colorSG = '#4fb7f3'
            // let colorSG='#ffffff'
            // const hostidC = devices_data.hosts.find(obj => obj.hostid === host.hostid)
            const relation = devices_data.relations.find(obj => obj.hostid === host.hostid)

            let hostidP = {}
            if (relation !== undefined) {
              hostidP = devices_data.hosts.find(obj => obj.hostid === relation.hostidP)
              // ////////console.log(hostidP)
            }
            let severity = 0
            if (host.value === 0) {
              colorSG = '#1fee08'
              severity = -1
            } else

              if (host.severity == 1) {
                colorSG = '#ffee00'
                // severity=1
              } else if (host.severity == 2) {
                colorSG = '#ee9d08'
                // severity=2
              } else if (host.severity == 3) {
                colorSG = '#ee5c08'
                // severity=3
              } else if (host.severity == 4) {
                colorSG = '#ee0808'
                // severity=4
              }
            //azul #4fb7f3
            // verde "#1fee08"
            setMarkers(markers => [...markers, {
              type: 'Feature',
              properties: {
                correlarionid: host.correlarionid,
                hostidP: hostidP.hostid,
                hostidC: host.hostid,
                init_lat: hostidP.latitude,
                init_lon: hostidP.longitude,
                end_lat: host.latitude.replace(",", "."),
                end_lon: host.longitude.replace(",", "."),
                hostid: host.hostid,
                name_hostP: hostidP.Host,
                name_hostC: host.name,
                name_hostipP: hostidP.ip,
                name_hostipC: host.ip,
                Alineacion: host.value,
                color_alineacion: colorSG,
                severity: host.severity,
                metrica: metricaSelected,
                lg: 'lg'
              },
              geometry: {
                type: 'Point',
                coordinates: [host.longitude, host.latitude],
              },
            }])

          }
        } else {
          // console.log("**************resets***********")
          // console.log(host)
        }
      }
    }
    )
    setRenderCapas(prevState => ({
      ...prevState,
      switches: true
    }));
  }
  // function objeto_subgroup_info(devices_data){
  //   //////console.log(devices_data.subgroup_info)
  //   devices_data.subgroup_info.map((host, index, array)=>
  //       {
  //         if(ubicacion.dispId===12){
  //           if(host.length!==0 && host.latitudeP.replace(",", ".")>=-90 && host.latitudeP.replace(",", ".")<=90 && host.latitudeC.replace(",", ".")>=-90 && host.latitudeC.replace(",", ".")<=90){


  //             // //////console.log("indice"+index+" | tipo:"+host.type_connection)
  //             // //////console.log(hostSub   )
  //             let alineacion=0
  //             let severity=0


  //               let colorSG='#00ff70'


  //               if(host.severity==1){
  //                 colorSG='#ffee00'
  //                 // severity=1
  //               }else if(host.severity==2){
  //                 colorSG='#ee9d08'
  //                 // severity=2
  //               }else if(host.severity==3){
  //                 colorSG='#ee5c08'
  //                 // severity=3
  //               }else if(host.severity==4){
  //                 colorSG='#ee0808'
  //                 // severity=4
  //               }
  //             //azul #4fb7f3
  //             // verde "#1fee08"

  //             if(host.type_connection==1 && host.connectivity==1){
  //               // //////console.log("fibra optica")
  //               setMarkers1(markers1 =>[...markers1,{
  //                 type: 'Feature',
  //                 properties:{
  //                   correlarionid: host.relationid,
  //                   init_lat: host.latitudeP.replace(",", "."),
  //                   init_lon: host.longitudeP.replace(",", "."),
  //                   end_lat: host.latitudeC.replace(",", "."),
  //                   end_lon: host.longitudeC.replace(",", "."),
  //                   Metric:host.Metric,
  //                   name:host.name,
  //                   hostidC: host.hostidC,
  //                   hostidP: host.hostidP,
  //                   BitsSent: host.BitsSent,
  //                   color_alineacion:colorSG,
  //                   severity:(host.connectivity==0)?host.connectivity:host.severity,
  //                   type_connection: host.type_connection,
  //                   // severity:Math.floor(Math.random() * 4) + 1,
  //                   metrica:metricaSelected,
  //                 },
  //                 geometry: {
  //                   type: 'LineString',
  //                   coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                 },
  //               }])
  //             }else  if(host.type_connection==1 && host.connectivity==0){
  //               // //////console.log("fibra optica")
  //               setSwitchesDownFO(switchesDownFO =>[...switchesDownFO,{
  //                 type: 'Feature',
  //                 properties:{
  //                   correlarionid: host.relationid,
  //                   init_lat: host.latitudeP.replace(",", "."),
  //                   init_lon: host.longitudeP.replace(",", "."),
  //                   end_lat: host.latitudeC.replace(",", "."),
  //                   end_lon: host.longitudeC.replace(",", "."),
  //                   Metric:host.Metric,
  //                   name:host.name,
  //                   hostidC: host.hostidC,
  //                   hostidP: host.hostidP,
  //                   BitsSent: host.BitsSent,
  //                   color_alineacion:colorSG,
  //                   severity:0,
  //                   type_connection: host.type_connection,
  //                   // severity:Math.floor(Math.random() * 4) + 1,
  //                   metrica:metricaSelected,
  //                 },
  //                 geometry: {
  //                   type: 'LineString',
  //                   coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                 },
  //               }])
  //             }else  if(host.type_connection==2  && host.connectivity==1){
  //               // //////console.log("microonda")
  //               setMarkers2(markers2 =>[...markers2,{
  //                 type: 'Feature',
  //                 properties:{
  //                   correlarionid: host.relationid,
  //                   init_lat: host.latitudeP.replace(",", "."),
  //                   init_lon: host.longitudeP.replace(",", "."),
  //                   end_lat: host.latitudeC.replace(",", "."),
  //                   end_lon: host.longitudeC.replace(",", "."),
  //                   Metric:host.Metric,
  //                   name:host.name,
  //                   hostidC: host.hostidC,
  //                   hostidP: host.hostidP,
  //                   BitsSent: host.BitsSent,
  //                   color_alineacion:colorSG,
  //                   severity:(host.connectivity==0)?host.connectivity:host.severity,
  //                   type_connection: host.type_connection,
  //                   // severity:Math.floor(Math.random() * 4) + 1,
  //                   metrica:metricaSelected,
  //                 },
  //                 geometry: {
  //                   type: 'LineString',
  //                   coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                 },
  //               }])
  //             }else  if(host.type_connection==2 && host.connectivity==0){
  //               // //////console.log("fibra optica")
  //               setSwitchesDownMO(switchesDownMO =>[...switchesDownMO,{
  //                 type: 'Feature',
  //                 properties:{
  //                   correlarionid: host.relationid,
  //                   init_lat: host.latitudeP.replace(",", "."),
  //                   init_lon: host.longitudeP.replace(",", "."),
  //                   end_lat: host.latitudeC.replace(",", "."),
  //                   end_lon: host.longitudeC.replace(",", "."),
  //                   Metric:host.Metric,
  //                   name:host.name,
  //                   hostidC: host.hostidC,
  //                   hostidP: host.hostidP,
  //                   BitsSent: host.BitsSent,
  //                   color_alineacion:colorSG,
  //                   severity:0,
  //                   type_connection: host.type_connection,
  //                   // severity:Math.floor(Math.random() * 4) + 1,
  //                   metrica:metricaSelected,
  //                 },
  //                 geometry: {
  //                   type: 'LineString',
  //                   coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                 },
  //               }])
  //             }

  //             // setMarkers([markers1,markers2])
  //           //   //////console.log(markers1)
  //           //  //////console.log(markers2) 
  //             /****************************************************************** */

  //           }
  //         }else{
  //           if(ubiActual.dispId!=26 && ubiActual.dispId!=4 && ubiActual.dispId!=8){
  //           if(host.length!==0 && host.latitude.replace(",", ".")>=-90 && host.latitude.replace(",", ".")<=90 ){
  //             let colorSG='#4fb7f3'
  //             // let colorSG='#ffffff'
  //             // const hostidC = devices_data.hosts.find(obj => obj.hostid === host.hostid)
  //             const relation = devices_data.relations.find(obj => obj.hostid === host.hostid)

  //             let hostidP={}
  //             if(relation!==undefined){
  //              hostidP = devices_data.hosts.find(obj => obj.hostid === relation.hostidP)
  //             // ////////console.log(hostidP)
  //             }
  //               let severity=0
  //             if(host.value===0){
  //                 colorSG='#1fee08'
  //                 severity=-1
  //             }else

  //             if(host.severity==1){
  //               colorSG='#ffee00'
  //               // severity=1
  //             }else if(host.severity==2){
  //               colorSG='#ee9d08'
  //               // severity=2
  //             }else if(host.severity==3){
  //               colorSG='#ee5c08'
  //               // severity=3
  //             }else if(host.severity==4){
  //               colorSG='#ee0808'
  //               // severity=4
  //             }
  //             //azul #4fb7f3
  //             // verde "#1fee08"
  //             setMarkers(markers=>[...markers,{
  //               type: 'Feature',
  //               properties:{
  //                 correlarionid: host.correlarionid,
  //                 hostidP: hostidP.hostid,
  //                 hostidC: host.hostid,
  //                 init_lat: hostidP.latitude,
  //                 init_lon: hostidP.longitude,
  //                 end_lat: host.latitude.replace(",", "."),
  //                 end_lon: host.longitude.replace(",", "."),
  //                 hostid: host.hostid,
  //                 name_hostP:hostidP.Host,
  //                 name_hostC:host.name,
  //                 name_hostipP:hostidP.ip,
  //                 name_hostipC:host.ip,
  //                 Alineacion: host.value,
  //                 color_alineacion:colorSG,
  //                 severity:host.severity,
  //                 metrica:metricaSelected,
  //                 lg:'lg'
  //               },
  //               geometry: {
  //                 type: 'Point',
  //                 coordinates: [host.longitude, host.latitude],
  //               },
  //             }]) 

  //           }
  //         }else{
  //           // console.log("**************resets***********")
  //           // console.log(host)
  //         }
  //         }

  //     }
  //     )
  // }

  function objeto_relaciones(devices_data) {
    ////////console.log(devices_data.hosts)
    ////////console.log(devices_data.relations)
    devices_data.relations.map((host, index, array) => {
      // if (index === 1) {
      //   setUbicacion({latitud:host.init_lat,longitud:host.init_lon,groupid:ubicacion.groupid,dispId:ubicacion.dispId,templateId:ubicacion.templateId})
      //   //////console.log(host);
      // }
      if (host.length !== 0 && host.init_lat.replace(",", ".") >= -90 && host.init_lat.replace(",", ".") <= 90 && host.end_lat.replace(",", ".") >= -90 && host.end_lat.replace(",", ".") <= 90) {

        const hostidC = devices_data.hosts.find(obj => obj.hostid === host.hostidC)
        const hostidP = devices_data.hosts.find(obj => obj.hostid === host.hostidP)
        let hostSub = devices_data.subgroup_info.find(obj => obj.hostid === host.hostidC)

        // //////console.log(hostSub   )
        let alineacion = 0
        let severity = 0
        if (hostSub !== undefined) {
          alineacion = hostSub.value
          severity = hostSub.severity
        }

        let colorSG = '#00ff70'

        // if(alineacion>-60 && alineacion<=-50){
        //   colorSG='#ffee00'
        //   // severity=1
        // }else if(alineacion>-70 && alineacion<=-60){
        //   colorSG='#ee9d08'
        //   // severity=2
        // }else if(alineacion>-80 && alineacion<=-70){
        //   colorSG='#ee5c08'
        //   // severity=3
        // }else if(alineacion<=-80){
        //   colorSG='#ee0808'
        //   // severity=4
        // }
        if (severity == 1) {
          colorSG = '#ffee00'
          // severity=1
        } else if (severity == 2) {
          colorSG = '#ee9d08'
          // severity=2
        } else if (severity == 3) {
          colorSG = '#ee5c08'
          // severity=3
        } else if (severity == 4) {
          colorSG = '#ee0808'
          // severity=4
        }
        //azul #4fb7f3
        // verde "#1fee08"
        // console.log(hostidP,hostidC)
        if (hostidC != undefined && hostidP != undefined) {
          setLines(lines => [...lines, {
            type: 'Feature',
            properties: {
              correlarionid: host.correlarionid,
              hostidP: hostidP.hostid,
              hostidC: hostidC.hostid,
              init_lat: host.init_lat,
              init_lon: host.init_lon,
              end_lat: host.end_lat,
              end_lon: host.end_lon,
              hostid: host.id,
              name_hostP: hostidP.Host,
              name_hostC: hostidC.Host,
              Alineacion: alineacion,
              color_alineacion: colorSG,
              severity: severity,
              metrica: metricaSelected,
            },
            geometry: {
              type: 'LineString',
              coordinates: [[host.init_lon, host.init_lat], [host.end_lon, host.end_lat]],
            },
          }])
        }
        /****************************************************************** */

      } else {
        ////////console.log(host)
      }
    }
    )
  }

  // useEffect(() => {
  //   if (!mapAux || demoExcepciones.length === 0) return;

  //   const sourceId = 'source-etiquetas-excep';
  //   const layerId = 'layer-etiquetas-excep';

  //   try {
  //     const existingSource = mapAux.getSource(sourceId);

  //     if (!existingSource) {
  //       mapAux.addSource(sourceId, {
  //         type: 'geojson',
  //         data: { type: 'FeatureCollection', features: demoExcepciones }
  //       });

  //       mapAux.addLayer({
  //         id: layerId,
  //         type: 'symbol',
  //         source: sourceId,
  //         layout: {
  //           'text-field': ['get', 'label'],
  //           'text-size': 12,
  //           'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
  //           'text-variable-anchor': ['bottom'],
  //           'text-radial-offset': 1.5, // Desplazamiento hacia arriba del host
  //         },
  //         paint: {
  //           'text-color': '#ffffff',
  //           'text-halo-color': ['get', 'color'],
  //           'text-halo-width': 8, // Esto simula el fondo de color de la etiqueta
  //         }
  //       });
  //     } else {
  //       existingSource.setData({ type: 'FeatureCollection', features: demoExcepciones });
  //     }
  //   } catch (e) {
  //     console.warn("Error en capas de etiquetas:", e);
  //   }
  // }, [demoExcepciones, mapAux]);
  // Referencia para guardar los popups activos y poder borrarlos
  const excepcionPopupsRef = useRef({});

  useEffect(() => {
    if (!mapAux) return;

    // 1. Limpiar popups que ya no están en la lista (al eliminar del panel)
    Object.keys(excepcionPopupsRef.current).forEach((id) => {
      if (!demoExcepciones.find((ex) => ex.id === id)) {
        excepcionPopupsRef.current[id].remove();
        delete excepcionPopupsRef.current[id];
      }
    });

    // 2. Crear o actualizar popups nuevos
    demoExcepciones.forEach((ex) => {
      if (!excepcionPopupsRef.current[ex.id]) {
        const { label, color } = ex.properties;
        const coords = ex.geometry.coordinates;

        const popup = new mapboxgl.Popup({
          className: 'custom-popup-except',
          closeButton: false,
          closeOnClick: false,
          anchor: 'bottom', // Para que la punta quede abajo
          offset: [0, -10]  // Ajuste para que no tape el icono del host
        })
          .setLngLat(coords)
          .setHTML(`
            <div class='cont-except' style='border: 1px solid #ffffff;'>
              <div class='valexcept' style='background: ${color}'>
                <div class='txtexcept'>${label.toUpperCase()}</div>
              </div>
            </div>
          `)
          .addTo(mapAux);

        excepcionPopupsRef.current[ex.id] = popup;
      }
    });

    // Limpieza al desmontar el componente
    return () => {
      Object.values(excepcionPopupsRef.current).forEach(p => p.remove());
      excepcionPopupsRef.current = {};
    };
  }, [demoExcepciones, mapAux]);
  useEffect(() => {
    if (!mapAux || !allTrue) return;

    const sourceId = 'line-demo-relaciones';
    const layerId = 'layer-demo-relaciones';
    try {
      const existingSource = mapAux.getSource(sourceId);

      // CASO A: Crear todo
      if (demoRelaciones.length !== 0 && allTrue && !existingSource) {
        mapAux.addSource(sourceId, {
          type: 'geojson',
          data: { type: 'FeatureCollection', features: demoRelaciones }
        });

        mapAux.addLayer({
          id: layerId,
          type: 'line',
          source: sourceId,
          paint: {
            'line-color': '#08b4ee',
            'line-width': 8,
            'line-dasharray': [0, 4, 3]
          }
        });
        // Eventos de Mouse con 'map'
        mapAux.on('mouseleave', layerId, () => {
          mapAux.getCanvas().style.cursor = '';
          const popups = document.querySelectorAll('.custom-popup');
          popups.forEach(p => p.remove());
        });

        mapAux.on('mouseenter', layerId, (e) => {
          mapAux.getCanvas().style.cursor = 'pointer';

          const feature = e.features[0];
          const coordinates = calcularPuntoMedio(
            feature.geometry.coordinates[0],
            feature.geometry.coordinates[1]
          );
          const { throughput, dbm, label } = feature.properties;

          // Corregimos la asignación de Popup
          new mapboxgl.Popup({
            className: 'custom-popup',
            closeButton: false,
          })
            .setLngLat(coordinates)
            .setHTML(`
          <div style="background:#1a1a1acc; color:white; padding:8px; border:1px solid #07b0ff; border-radius:4px;">
            <b style="display:block; border-bottom:1px solid #555; margin-bottom:5px;">${label || '45 Mbps'}</b>
            <div style="font-size:11px;">Estado: <span style="color:#1fee08">Estable</span></div>
            <div style="font-size:11px;">Throughput: ${throughput || '45 Mbps'}</div>
            <div style="font-size:11px;">Alineación: ${dbm || '-43 dBm'}</div>
          </div>
        `)
            .addTo(mapAux);
        });
        // Iniciamos la animación
        startDemoAnimation(mapAux, layerId);
      }

      // CASO B: Actualizar
      else if (existingSource) {
        existingSource.setData({
          type: 'FeatureCollection',
          features: demoRelaciones
        });
      }
    } catch (error) {
      // Esto silencia los errores de "getLayer" o "getSource" en pantalla
      console.warn("Error controlado al manipular capas del mapa:", error.message);
    }

    // Limpieza al desmontar: ayuda a detener procesos pendientes
    return () => {
      try {
        if (mapAux.getLayer(layerId)) mapAux.removeLayer(layerId);
        if (mapAux.getSource(sourceId)) mapAux.removeSource(sourceId);
      } catch (e) {
        // Silenciamos también el error durante el desmontaje
      }
    };
  }, [demoRelaciones, mapAux, allTrue]);
  function calcularPuntoMedio(coordenadas1, coordenadas2) {
    // Extraer las coordenadas de los puntos
    const [x1, y1] = coordenadas1;
    const [x2, y2] = coordenadas2;

    // Calcular el punto medio
    const puntoMedioX = (x1 + x2) / 2;
    const puntoMedioY = (y1 + y2) / 2;

    return [puntoMedioX, puntoMedioY];
  }
  // useEffect(() => {
  //   const map = mapAux?.current;
  //   if (!map || typeof map.getSource !== 'function') {
  //     console.log("El mapa aún no está listo o la referencia es incorrecta");
  //     return;
  //   }
  //   if (!mapAux || !mapAux.isStyleLoaded() || !allTrue) return;
  // if (!map.isStyleLoaded()) return;
  //   const sourceId = 'line-demo-relaciones';
  //   const layerId = 'layer-demo-relaciones';
  //   const existingSource = mapAux.getSource(sourceId);
  // let Popup;
  //   // 1. CREACIÓN DE FUENTE Y CAPA
  //   if (demoRelaciones.length !== 0 && !existingSource) {
  //     mapAux.addSource(sourceId, {
  //       type: 'geojson',
  //       data: { type: 'FeatureCollection', features: demoRelaciones }
  //     });

  //     mapAux.addLayer({
  //       id: layerId,
  //       type: 'line',
  //       source: sourceId,
  //       paint: {
  //         'line-color': '#08b4ee',
  //         'line-width': 10,
  //         'line-dasharray': [0, 4, 3],
  //         // 'line-opacity': 0,
  //       }
  //     });

  //     // 2. EVENTOS DE MOUSE (Tu lógica personalizada)
  //     mapAux.on('mouseleave', layerId, () => {
  //       mapAux.getCanvas().style.cursor = '';
  //       const popups = document.querySelectorAll('.custom-popup');
  //       popups.forEach(popup => popup.remove());
  //     });
  // mapAux.on('mouseenter', `${layerId}-hitbox`, (e) => { console.log('-------------hitbox-------------------------------') });
  //    mapAux.on('mouseenter', layerId, (e) => {
  //     mapAux.getCanvas().style.cursor = 'pointer';
  //     console.log('--------------------------------------------')
  //                      // console.log(e.features[0].properties.Metric)
  //                      // console.log(JSON.parse(e.features[0].properties.Metric))
  //                      const coordinates = calcularPuntoMedio(e.features[0].geometry.coordinates[0],e.features[0].geometry.coordinates[1])
  //                    // console.log(coordinates)
  //                   //  const data=JSON.parse(e.features[0].properties.Metric)
  //                      //   const coordinates = e.features[0].geometry.coordinates.slice();
  //                      const feature = e.features[0];
  //         const { label, throughput, dbm } = feature.properties;

  //                      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
  //                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
  //                      }

  //                      Popup= new mapboxgl.Popup({
  //                        className: 'custom-popup',
  //                        closeButton: false,
  //                    })
  //                        .setLngLat(coordinates)

  //                        .setHTML(`
  //                         <div style="background:#dededec3; color:white; padding:8px; border:1px solid #07b0ff; border-radius:4px;">
  //             <b style="display:block; border-bottom:1px solid #dededec3; margin-bottom:5px;">${'Simulado'}</b>
  //             <div style="font-size:11px;">Estado: <span style="color:#1fee08">Estable</span></div>
  //             <div style="font-size:11px;">Throughput: ${throughput || '45 Mbps'}</div>
  //             <div style="font-size:11px;">Alineación: ${dbm || '-43 dBm'}</div>
  //           </div>
  //                         `)
  //                        .addTo(mapAux);
  //                    });

  //     startDemoAnimation(mapAux, layerId);
  //   } 

  //   // 3. ACTUALIZACIÓN DE DATOS
  //   else if (existingSource) {
  //     existingSource.setData({
  //       type: 'FeatureCollection',
  //       features: demoRelaciones
  //     });
  //   }
  // }, [demoRelaciones]);
  // Función de apoyo para la animación (fuera del useEffect)
  // useEffect(() => {
  //   const map =mapAux|| mapAux?.current;
  // console.log('line 1')
  //   // 1. Guardias de seguridad: salir si no hay mapa o el estilo no está listo
  //   console.log('¿Qué es map?', map);

  //   if (!map) {
  //       console.log('Error: La referencia está vacía');
  //       return;
  //   }

  //   if (typeof map.getSource !== 'function') {
  //       console.log('Error: map existe pero NO es un objeto de Mapbox. Es un:', map.constructor.name);
  //       return;
  //   }

  //   console.log('¡Bingo! El mapa es correcto y tiene métodos.');
  //   if (!map || typeof map.getSource !== 'function') return;
  //   console.log('line 2',map)
  //   // if (!map.isStyleLoaded() || !allTrue) return;
  //   if (!map.isStyleLoaded()) {
  //     console.log("El estilo no ha cargado, esperando...");
  //     // Forzamos un re-intento cuando el estilo cargue
  //     map.once('style.load', () => { /* Esto disparará el re-render */ });
  //     return; 
  // }

  // // 2. Verifica si allTrue realmente es lo que esperas
  // if (!allTrue) {
  //     console.log("allTrue es falso, la simulación está apagada");
  //     return;
  // }
  // console.log('line 22')
  //   const sourceId = 'line-demo-relaciones';
  //   const layerId = 'layer-demo-relaciones';

  //   // IMPORTANTE: Usar 'map', no 'mapAux'
  //   const existingSource = map.getSource(sourceId);

  //   // 2. CREACIÓN (Solo si no existe y hay datos)
  //   if (demoRelaciones.length !== 0 && !existingSource) {
  //     console.log('line 3')
  //     map.addSource(sourceId, {
  //       type: 'geojson',
  //       data: { type: 'FeatureCollection', features: demoRelaciones }
  //     });

  //     map.addLayer({
  //       id: layerId,
  //       type: 'line',
  //       source: sourceId,
  //       paint: {
  //         'line-color': '#08b4ee',
  //         'line-width': 10,
  //         'line-dasharray': [0, 4, 3],
  //       }
  //     });

  //     // Eventos de Mouse con 'map'
  //     map.on('mouseleave', layerId, () => {
  //       map.getCanvas().style.cursor = '';
  //       const popups = document.querySelectorAll('.custom-popup');
  //       popups.forEach(p => p.remove());
  //     });

  //     map.on('mouseenter', layerId, (e) => {
  //       map.getCanvas().style.cursor = 'pointer';

  //       const feature = e.features[0];
  //       const coordinates = calcularPuntoMedio(
  //         feature.geometry.coordinates[0],
  //         feature.geometry.coordinates[1]
  //       );
  //       const { throughput, dbm } = feature.properties;

  //       // Corregimos la asignación de Popup
  //       new mapboxgl.Popup({
  //         className: 'custom-popup',
  //         closeButton: false,
  //       })
  //       .setLngLat(coordinates)
  //       .setHTML(`
  //         <div style="background:#1a1a1acc; color:white; padding:8px; border:1px solid #07b0ff; border-radius:4px;">
  //           <b style="display:block; border-bottom:1px solid #555; margin-bottom:5px;">Simulado</b>
  //           <div style="font-size:11px;">Estado: <span style="color:#1fee08">Estable</span></div>
  //           <div style="font-size:11px;">Throughput: ${throughput || '45 Mbps'}</div>
  //           <div style="font-size:11px;">Alineación: ${dbm || '-43 dBm'}</div>
  //         </div>
  //       `)
  //       .addTo(map);
  //     });

  //     startDemoAnimation(map, layerId);

  //   } 
  //   // 3. ACTUALIZACIÓN (Si ya existe)
  //   else if (existingSource) {
  //     existingSource.setData({
  //       type: 'FeatureCollection',
  //       features: demoRelaciones
  //     });
  //   }
  // }, [demoRelaciones]); // Añadí allTrue aquí por si cambia
  function startDemoAnimation(map, layerId) {
    const dashArraySequence = [
      [0, 0.3, 0.2], [0, 0.1, 0.2, 0.4], [0, 0.2, 0.2, 0.3],
      [0, 0.3, 0.2, 0.2], [0, 0.4, 0.2, 0.1], [0, 0.5, 0.2, 0]
    ];
    let step = 0;
    let requestId; // 🆔 Guardaremos el ID de la animación para poder cancelarla

    function animate(timestamp) {
      // 🛑 VALIDACIÓN CRÍTICA: Si el mapa no existe o no tiene estilo, salimos
      if (!map || !map.getStyle()) {
        cancelAnimationFrame(requestId);
        return;
      }

      const newStep = Math.floor((timestamp / 50) % dashArraySequence.length);

      if (newStep !== step) {
        // 🔍 Verificamos que la capa siga existiendo antes de actuar
        if (map.getLayer(layerId)) {
          try {
            map.setPaintProperty(layerId, 'line-dasharray', dashArraySequence[newStep]);
            step = newStep;
          } catch (e) {
            console.warn("Error al animar:", e);
            return; // Detenemos si algo falla internamente
          }
        } else {
          return; // La capa ya no está, dejamos de pedir cuadros
        }
      }

      requestId = requestAnimationFrame(animate);
    }

    requestId = requestAnimationFrame(animate);

    // Retornamos una función para limpiar desde el useEffect
    return () => cancelAnimationFrame(requestId);
  }
  function objeto_switches(devices_data) {
    if (devices_data.correlations.length != 0) {
      devices_data.correlations.map((host, index, array) => {
        // console.log(host)
        // if(ubicacion.dispId===12){
        if (true) {
          if (host.length !== 0 && host.lat_padre.replace(",", ".") >= -90 && host.lat_padre.replace(",", ".") <= 90 && host.lat_hijo.replace(",", ".") >= -90 && host.lat_hijo.replace(",", ".") <= 90) {


            // console.log("indice"+index+" | tipo:"+host.medio_id+" | status: "+host.valor_status_enlace)
            // //////console.log(hostSub   )
            let alineacion = 0
            let severity = 0


            let colorSG = '#00ff70'


            if (host.valor_status_enlace == 1) {
              colorSG = 'lime'
              // severity=1
            } else if (host.valor_status_enlace == null) {
              colorSG = 'grey'
              // severity=1
            } else if (host.severity == 0) {
              colorSG = 'red'
              // severity=2
            }
            //azul #4fb7f3
            // verde "#1fee08"
            if (host.medio_id == 1 && (host.valor_status_enlace == 1 || host.valor_status_enlace == null)) {
              // //////console.log("fibra optica")
              setSwitchesFO(switchesFO => [...switchesFO, {
                type: 'Feature',
                properties: {
                  correlarionid: host.relationid,
                  init_lat: host.lat_padre.replace(",", "."),
                  init_lon: host.lon_padre.replace(",", "."),
                  end_lat: host.lat_hijo.replace(",", "."),
                  end_lon: host.lon_hijo.replace(",", "."),
                  Metric: host,
                  // name:host.name,
                  hostidC: host.host_hijo_id,
                  hostidP: host.host_padre_id,
                  //BitsSent: host.BitsSent,
                  color_alineacion: colorSG,
                  severity: host.severity,
                  type_connection: host.medio_id,
                  connectivity: host.valor_status_enlace,
                  // severity:Math.floor(Math.random() * 4) + 1,
                  metrica: metricaSelected,
                },
                geometry: {
                  type: 'LineString',
                  coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
                },
              }])
            } else if (host.medio_id == 1 && host.valor_status_enlace == 0) {
              // //////console.log("fibra optica")
              setSwitchesDownFO(switchesDownFO => [...switchesDownFO, {
                type: 'Feature',
                properties: {
                  correlarionid: host.relationid,
                  init_lat: host.lat_padre.replace(",", "."),
                  init_lon: host.lon_padre.replace(",", "."),
                  end_lat: host.lat_hijo.replace(",", "."),
                  end_lon: host.lon_hijo.replace(",", "."),
                  Metric: host,
                  // name:host.name,
                  hostidC: host.host_hijo_id,
                  hostidP: host.host_padre_id,
                  //BitsSent: host.BitsSent,
                  color_alineacion: colorSG,
                  severity: host.severity,
                  type_connection: host.medio_id,
                  connectivity: host.valor_status_enlace,
                  // severity:Math.floor(Math.random() * 4) + 1,
                  metrica: metricaSelected,
                },
                geometry: {
                  type: 'LineString',
                  coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
                },
              }])
            } else if (host.medio_id == 2 && (host.valor_status_enlace == 1 || host.valor_status_enlace == null)) {
              // console.log("microonda")
              setSwitchesMO(switchesMO => [...switchesMO, {
                type: 'Feature',
                properties: {
                  correlarionid: host.relationid,
                  init_lat: host.lat_padre.replace(",", "."),
                  init_lon: host.lon_padre.replace(",", "."),
                  end_lat: host.lat_hijo.replace(",", "."),
                  end_lon: host.lon_hijo.replace(",", "."),
                  Metric: host,
                  // name:host.name,
                  hostidC: host.host_hijo_id,
                  hostidP: host.host_padre_id,
                  //BitsSent: host.BitsSent,
                  color_alineacion: colorSG,
                  severity: host.severity,
                  type_connection: host.medio_id,
                  connectivity: host.valor_status_enlace,
                  // severity:Math.floor(Math.random() * 4) + 1,
                  metrica: metricaSelected,
                },
                geometry: {
                  type: 'LineString',
                  coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
                },
              }])
            } else if (host.medio_id == 2 && host.valor_status_enlace == 0) {
              // console.log("fibra optica")
              setSwitchesDownMO(switchesDownMO => [...switchesDownMO, {
                type: 'Feature',
                properties: {
                  correlarionid: host.relationid,
                  init_lat: host.lat_padre.replace(",", "."),
                  init_lon: host.lon_padre.replace(",", "."),
                  end_lat: host.lat_hijo.replace(",", "."),
                  end_lon: host.lon_hijo.replace(",", "."),
                  Metric: host,
                  // name:host.name,
                  hostidC: host.host_hijo_id,
                  hostidP: host.host_padre_id,
                  //BitsSent: host.BitsSent,
                  color_alineacion: colorSG,
                  severity: host.severity,
                  type_connection: host.medio_id,
                  connectivity: host.valor_status_enlace,
                  // severity:Math.floor(Math.random() * 4) + 1,
                  metrica: metricaSelected,
                },
                geometry: {
                  type: 'LineString',
                  coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
                },
              }])
            }

            // setMarkers([markers1,markers2])
            //   //////console.log(markers1)
            //  //////console.log(markers2) 
            /****************************************************************** */

          }
        } else {

        }

      }
      )
    } else {
      setRenderCapas(prevState => ({
        ...prevState,
        switches: true
      }));
    }
  }
  // function objeto_switches(devices_data){
  //   console.log("entra al objeto switches -----------------------------")
  //   console.log(devices_data.subgroup_info)
  //   if(devices_data.subgroup_info.length!=0){
  //     devices_data.subgroup_info.map((host, index, array)=>
  //         {
  //           // console.log(host)
  //           if(ubicacion.dispId===12){

  //             if(host.length!==0 && host.latitudeP.replace(",", ".")>=-90 && host.latitudeP.replace(",", ".")<=90 && host.latitudeC.replace(",", ".")>=-90 && host.latitudeC.replace(",", ".")<=90){


  //               // console.log("indice"+index+" | tipo:"+host.type_connection+" | status: "+host.connectivity)
  //               // //////console.log(hostSub   )
  //               let alineacion=0
  //               let severity=0


  //                 let colorSG='#00ff70'


  //                 if(host.connectivity==1){
  //                   colorSG='lime'
  //                   // severity=1
  //                 }else if(host.severity==0){
  //                   colorSG='red'
  //                   // severity=2
  //                 }
  //               //azul #4fb7f3
  //               // verde "#1fee08"
  //               if(host.type_connection==1 && host.connectivity==1){
  //                 // //////console.log("fibra optica")
  //                 setSwitchesFO(switchesFO =>[...switchesFO,{
  //                   type: 'Feature',
  //                   properties:{
  //                     correlarionid: host.relationid,
  //                     init_lat: host.latitudeP.replace(",", "."),
  //                     init_lon: host.longitudeP.replace(",", "."),
  //                     end_lat: host.latitudeC.replace(",", "."),
  //                     end_lon: host.longitudeC.replace(",", "."),
  //                     Metric:host.Metric,
  //                     name:host.name,
  //                     hostidC: host.hostidC,
  //                     hostidP: host.hostidP,
  //                     BitsSent: host.BitsSent,
  //                     color_alineacion:colorSG,
  //                     severity:host.severity,
  //                     type_connection: host.type_connection,
  //                     connectivity:host.connectivity,
  //                     // severity:Math.floor(Math.random() * 4) + 1,
  //                     metrica:metricaSelected,
  //                   },
  //                   geometry: {
  //                     type: 'LineString',
  //                     coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                   },
  //                 }])
  //               }else if(host.type_connection==1 && host.connectivity==0){
  //                 // //////console.log("fibra optica")
  //                 setSwitchesDownFO(switchesDownFO =>[...switchesDownFO,{
  //                   type: 'Feature',
  //                   properties:{
  //                     correlarionid: host.relationid,
  //                     init_lat: host.latitudeP.replace(",", "."),
  //                     init_lon: host.longitudeP.replace(",", "."),
  //                     end_lat: host.latitudeC.replace(",", "."),
  //                     end_lon: host.longitudeC.replace(",", "."),
  //                     Metric:host.Metric,
  //                     name:host.name,
  //                     hostidC: host.hostidC,
  //                     hostidP: host.hostidP,
  //                     BitsSent: host.BitsSent,
  //                     color_alineacion:colorSG,
  //                     severity:host.severity,
  //                     type_connection: host.type_connection,
  //                     connectivity:host.connectivity,
  //                     // severity:Math.floor(Math.random() * 4) + 1,
  //                     metrica:metricaSelected,
  //                   },
  //                   geometry: {
  //                     type: 'LineString',
  //                     coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                   },
  //                 }])
  //               } else if(host.type_connection==2 && host.connectivity==1){
  //                 // console.log("microonda")
  //                 setSwitchesMO(switchesMO =>[...switchesMO,{
  //                   type: 'Feature',
  //                   properties:{
  //                     correlarionid: host.relationid,
  //                     init_lat: host.latitudeP.replace(",", "."),
  //                     init_lon: host.longitudeP.replace(",", "."),
  //                     end_lat: host.latitudeC.replace(",", "."),
  //                     end_lon: host.longitudeC.replace(",", "."),
  //                     Metric:host.Metric,
  //                     name:host.name,
  //                     hostidC: host.hostidC,
  //                     hostidP: host.hostidP,
  //                     BitsSent: host.BitsSent,
  //                     color_alineacion:colorSG,
  //                     severity:host.severity,
  //                     type_connection: host.type_connection,
  //                     connectivity:host.connectivity,
  //                     // severity:Math.floor(Math.random() * 4) + 1,
  //                     metrica:metricaSelected,
  //                   },
  //                   geometry: {
  //                     type: 'LineString',
  //                     coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                   },
  //                 }])
  //               }else if(host.type_connection==2 && host.connectivity==0){
  //                 // console.log("fibra optica")
  //                 setSwitchesDownMO(switchesDownMO =>[...switchesDownMO,{
  //                   type: 'Feature',
  //                   properties:{
  //                     correlarionid: host.relationid,
  //                     init_lat: host.latitudeP.replace(",", "."),
  //                     init_lon: host.longitudeP.replace(",", "."),
  //                     end_lat: host.latitudeC.replace(",", "."),
  //                     end_lon: host.longitudeC.replace(",", "."),
  //                     Metric:host.Metric,
  //                     name:host.name,
  //                     hostidC: host.hostidC,
  //                     hostidP: host.hostidP,
  //                     BitsSent: host.BitsSent,
  //                     color_alineacion:colorSG,
  //                     severity:host.severity,
  //                     type_connection: host.type_connection,
  //                     connectivity:host.connectivity,
  //                     // severity:Math.floor(Math.random() * 4) + 1,
  //                     metrica:metricaSelected,
  //                   },
  //                   geometry: {
  //                     type: 'LineString',
  //                     coordinates: [[host.longitudeP.replace(",", "."), host.latitudeP.replace(",", ".")], [host.longitudeC.replace(",", "."), host.latitudeC.replace(",", ".")]],
  //                   },
  //                 }])
  //               }

  //               // setMarkers([markers1,markers2])
  //             //   //////console.log(markers1)
  //             //  //////console.log(markers2) 
  //               /****************************************************************** */

  //             }
  //           }else{

  //           }

  //       }
  //       )
  //   }else{
  //     setRenderCapas(prevState => ({
  //       ...prevState,
  //       switches: true 
  //     }));
  //   }
  // }
  // function objeto_switches(switch_list){
  //   //////console.log(switch_list)
  //   ////////console.log(devices_data.relations)
  //   switch_list.map((host, index, array)=>
  //       {
  //         // if (index === 1) {
  //         //   setUbicacion({latitud:host.init_lat,longitud:host.init_lon,groupid:ubicacion.groupid,dispId:ubicacion.dispId,templateId:ubicacion.templateId})
  //         //   ////////console.log('Recorrido completo');
  //         // }
  //         if(host.length!==0 && host.latitude_p.replace(",", ".")>=-90 && host.latitude_p.replace(",", ".")<=90 && host.latitude_c.replace(",", ".")>=-90 && host.latitude_c.replace(",", ".")<=90){


  //             let colorSG='#00ff70'


  //           if(host.Metric==1){
  //             colorSG='#4fb7f3'
  //             // severity=1
  //           }else{
  //             colorSG='#ee0808'
  //           }

  //           //azul #4fb7f3
  //           // verde "#1fee08"


  //           setSwitches(lines=>[...lines,{
  //             type: 'Feature',
  //             properties:{
  //               name:host.name,
  //               date:host.Date,
  //               hostidP: host.hostidP,
  //               hostidC: host.hostidC,
  //               init_lat: host.latitude_p,
  //               init_lon: host.longitude_p,
  //               end_lat: host.latitude_c,
  //               end_lon: host.longitude_c,
  //               color_alineacion:colorSG,
  //               severity:host.Metric,
  //               metrica:metricaSelected,
  //             },
  //             geometry: {
  //               type: 'LineString',
  //               coordinates: [[host.longitude_p, host.latitude_p], [host.longitude_c, host.latitude_c]],
  //             },
  //           }])
  //           /****************************************************************** */

  //         }else{
  //           ////////console.log(host)
  //         }
  //     }
  //     )
  // }
  /************************************************************************************ */
  function objeto_markers_wor(devices_data) {
    let flag_ubicacion = false
    // if (devices_data.hosts.length == 0){
    // setRenderCapas(prevState => ({
    //     ...prevState,
    //     markersWOR: true 
    //   }));
    // }
    devices_data.hosts.map((host, index, array) => {
      if (!flag_ubicacion) {
        if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {
          setUbicacion({ latitud: host.latitude, longitud: host.longitude, groupid: ubicacion.groupid, dispId: ubicacion.dispId, templateId: ubicacion.templateId })
          // //////console.log(host);
          flag_ubicacion = true
        }
      }
      // //////console.log(host.ip,host.latitude)
      if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {

        // const hostidC = devices_data.relations.find(obj => obj.hostidC === host.hostid)
        // const hostidP = devices_data.relations.find(obj => obj.hostidCP === host.hostid)

        // const lon = devices_data.relations.find(obj => obj.end_lon === host.longitude)
        // const lat = devices_data.relations.find(obj => obj.end_lat === host.latitude)
        const lon = devices_data.subgroup_info.find(obj => obj.longitude === host.longitude)
        const lat = devices_data.subgroup_info.find(obj => obj.latitude === host.latitude)
        const reset_info = devices_data.subgroup_info.find(obj => obj.hostid === host.hostid)
        // console.log("***************************reset_info")
        // console.log(reset_info)
        // console.log("LEVEL:",((host.device_id==26 || host.device_id==4 || host.device_id==8 ) && reset_info!=undefined  && ubicacion.templateId!='')?((reset_info.metrics.length==0)?0:(reset_info.metrics[0].level==undefined?-1:reset_info.metrics[0].level)):-1)
        // console.log((reset_info.metrics.length==0)?'#4fb7f3':reset_info.metrics[0].value)
        // console.log(((reset_info.metrics.length==0)?'#4fb7f3':((reset_info.metrics[0].value>23)?'#00ff70':(reset_info.metrics[0].value>20)?'#ee5c08':'#ffee00')))
        let colorSG = '#00ff70'
        let severity = 0
        let tooltip = false;
        if (lon === undefined && lon === undefined) {
          tooltip = true

        }
        else {
          tooltip = false
        }
        //azul #4fb7f3
        // verde "#1fee08"
        const levels_colors = ['#c1c1c1b0', '#00ff70', '#ffee00', '#ee5c08']
        if (!exceptions_list.data.some(u => u.hostid === host.hostid)) {
          setMarkersWOR(markersWOR => [...markersWOR, {
            type: 'Feature',
            properties: {
              hostidC: host.hostid,
              hostidP: '',
              end_lat: host.latitude.replace(",", "."),
              end_lon: host.longitude.replace(",", "."),
              name_hostC: host.Host,
              name_hostipC: host.ip,
              color_alineacion2: (host.device_id != -1 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? '#757575af' : ((reset_info.metrics[0].value > 23) ? '#00ff70' : (reset_info.metrics[0].value < 20) ? '#ee5c08' : '#ffee00')) : colorSG,
              color_alineacion: ((host.device_id != -1) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? levels_colors[0] : levels_colors[reset_info.metrics[0].level]) : colorSG,
              tooltip: tooltip,
              device_id: host.device_id,
              metrics: ((host.device_id != -1) && reset_info != undefined) ? reset_info.metrics : [],
              level: ((host.device_id != -1) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? 0 : (reset_info.metrics[0].level == undefined ? -1 : reset_info.metrics[0].level)) : -1,
              status: (host.device_id == 26 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? 0 : ((reset_info.metrics[0].value > 23) ? 1 : (reset_info.metrics[0].value < 20) ? 3 : 2)) : -1
            },
            geometry: {
              type: 'Point',
              coordinates: [host.longitude.replace(",", "."), host.latitude.replace(",", ".")],
            },
          }])
        }


        /****************************************************************** */

      } else {
        // ////////console.log(host)
      }
    }
    )
  }
  /********************************************************************************************** */
  function objeto_markers_unknown(devices_data) {
    let flag_ubicacion = false
    devices_data.host_unknown.map((host, index, array) => {
      if (!flag_ubicacion) {
        if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {
          setUbicacion({ latitud: host.latitude, longitud: host.longitude, groupid: ubicacion.groupid, dispId: ubicacion.dispId, templateId: ubicacion.templateId })
          // console.log(host);
          flag_ubicacion = true
        }
      }
      // //////console.log(host.ip,host.latitude)
      if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {

        // const hostidC = devices_data.relations.find(obj => obj.hostidC === host.hostid)
        // const hostidP = devices_data.relations.find(obj => obj.hostidCP === host.hostid)

        // const lon = devices_data.relations.find(obj => obj.end_lon === host.longitude)
        // const lat = devices_data.relations.find(obj => obj.end_lat === host.latitude)
        const lon = devices_data.subgroup_info.find(obj => obj.longitude === host.longitude)
        const lat = devices_data.subgroup_info.find(obj => obj.latitude === host.latitude)
        const reset_info = devices_data.subgroup_info.find(obj => obj.hostid === host.hostid)
        // console.log(reset_info)
        let colorSG = '#00ff70'
        let severity = 0
        let tooltip = false;
        if (lon === undefined && lon === undefined) {
          tooltip = true

        }
        else {
          tooltip = false
        }
        if (!exceptions_list.data.some(u => u.hostid === host.hostid)) {
          //  console.log(host.device_id, reset_info)
          // console.log(((host.device_id==26 || host.device_id==4 ||host.device_id==8) && reset_info!=undefined)?reset_info.metrics:[])
          setMarkersUnknown(markersWOR => [...markersWOR, {
            type: 'Feature',
            properties: {
              hostidC: host.hostid,
              hostidP: '',
              end_lat: host.latitude.replace(",", "."),
              end_lon: host.longitude.replace(",", "."),
              name_hostC: host.Host,
              name_hostipC: host.ip,
              color_alineacion: "#3c3c3c",
              type: 'Unknown',
              tooltip: tooltip,
              device_id: host.device_id,
              metrics: ((host.device_id != -1) && reset_info != undefined) ? reset_info.metrics : [],
              level: ((host.device_id != -1) && reset_info != undefined && ubicacion.templateId != '') ? ((reset_info.metrics.length == 0) ? 0 : (reset_info.metrics[0].level == undefined ? -1 : reset_info.metrics[0].level)) : -1,
              status: (host.device_id == 26 && ubicacion.templateId == 'reset_extpwr') ? ((reset_info.metrics.length == 0) ? 0 : ((reset_info.metrics[0].value > 23) ? 1 : (reset_info.metrics[0].value < 20) ? 3 : 2)) : -1
            },
            geometry: {
              type: 'Point',
              coordinates: [host.longitude.replace(",", "."), host.latitude.replace(",", ".")],
            },
          }])
        } else { }


        /****************************************************************** */

      } else { }
    }
    )
  }
  function objeto_antenas(devices_data) {
    devices_data.hosts.map((host, index, array) => {
      // if (index === 1) {
      //   setUbicacion({latitud:host.latitude,longitud:host.longitude,groupid:ubicacion.groupid,dispId:ubicacion.dispId,templateId:ubicacion.templateId})
      //   //////console.log(host);
      // }
      if (host.length !== 0 && host.latitude.replace(",", ".") >= -90 && host.latitude.replace(",", ".") <= 90) {


        setLatitudes(latitudes => [...latitudes, {
          type: 'scattermapbox',
          lat: [host.latitude],
          lon: [host.longitude],
          text: [host.Host],
          mode: 'markers',
          hovertext: [host.Host],
          marker: { size: [14], color: ['#ffffff'], symbol: 'marker' },
          name: '',
          hovertemplate:
            "<b>%{customdata.short_name}...</b><br><br>",

          hoverlabel: { bgcolor: "#181818", bordercolor: "#1fee08", namelength: 20, font: { color: "#FFF" } },
          customdata: [
            {
              nivel: 1,
              name: host.Host,
              ip: host.ip,
              id: host.hostid,
              short_name: host.Host.slice(0, 30),
              alineacion: 0
            }
          ],
          buffer: 512,

        }])
        /****************************************************************** */

      } else {
        ////////console.log(host)
      }
    }
    )
  }
  const infoMarkerStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '70%',
      height: '60%',
      padding: '20px'
    },
  };
  const [infoMarkerOpen, setInfoMarkerOpen] = useState(false);
  const [infoMarker, setInfoMarker] = useState([])
  function openInfoMarker() {
    setInfoMarkerOpen(true);
  }

  function closeInfoMarker() {
    setInfoMarkerOpen(false);
  }
  useEffect(() => {
    //////console.log("se inicia el monitoreo")
  }, [])
  const handleMarkerClick = (data) => {
    ////console.log(data)
    setInfoMarker(data)
    openInfoMarker()
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  function actualizar_rfi(map, popup2, rfidI) {
    // //////console.log(map.getSource('host-rfid'))
    try {
      //   //////console.log("actualizar_rfi rfidInterval")
      // //////console.log(rfidI)
      setRfidInterval(rfidI)
      setRfidData({ map: map, getSource: map.getSource('host-rfid'), popup: popup2 })

      setRfid([])
      search_rfid()
    } catch (error) {
      clearInterval(rfidI);
    }


  }

  function actualizar_layer_rfid(rfid) {

    const popups = document.querySelectorAll('.custom-popup-rfid');

    popups.forEach(popup => {

      popup.remove();
    });

    // var popup;
    if (Object.keys(rfidData.map).length !== 0) {
      rfid.forEach((feature) => {
        const coordinates = feature.geometry.coordinates.slice();
        // //////console.log(coordinates)
        const val = feature.properties.lecturas; // Asegúrate de tener esta propiedad en tus datos
        const severity = feature.properties.severidad;
        const severity_colors = {
          1: '#ffee00',
          2: '#ee9d08',
          3: '#ee5c08',
          4: '#ff0808',
        }
        let popup = new mapboxgl.Popup({
          className: 'custom-popup-rfid',
          closeButton: false,
          closeOnClick: false
        })
          .setLngLat(coordinates)
          .setHTML(`<div class='cont-rfid' style='border: 1px solid #ffffff;'>
        <div class='titleRFID'><div class='txtTitleRfid'>Trafico</div><br></div>
        <div class='valRFID' style='background: ${severity_colors[severity]}'><div class='txtRfid' style='color: ${((severity != 0) ? 'black !important' : 'lime')}'>${val}</div><br><br></div>
            
            </div>`)
          .addTo(rfidData.map);
      });
    }



  }
  function actualizar_lpr(map, popup2, lprI) {
    // //////console.log(map.getSource('host-rfid'))
    try {
      //   //////console.log("actualizar_rfi rfidInterval")
      // //////console.log(rfidI)
      setLprInterval(lprI)
      setLprData({ map: map, getSource: map.getSource('host-lpr'), popup: popup2 })

      setLpr([])
      search_lpr()
    } catch (error) {
      //////console.log("error:",lprI)
      clearInterval(lprI);
      // //////console.log(error)
    }


  }
  function actualizar_layer_lpr(lpr) {

    const popups = document.querySelectorAll('.custom-popup-lpr');

    popups.forEach(popup => {

      popup.remove();
    });

    // var popup;
    if (Object.keys(lprData.map).length !== 0) {
      lpr.forEach((feature) => {
        const coordinates = feature.geometry.coordinates.slice();
        // //////console.log(coordinates)
        const val = feature.properties.lecturas; // Asegúrate de tener esta propiedad en tus datos
        const severity = feature.properties.severidad;
        const activo = feature.properties.activo;
        const severity_colors = {
          1: '#ffee00',
          2: '#ee9d08',
          3: '#ee5c08',
          4: '#ff0808',
        }
        let popup = new mapboxgl.Popup({
          className: 'custom-popup-lpr',
          closeButton: false,
          closeOnClick: false
        })
          .setLngLat(coordinates)
          .setHTML(`<div class='cont-lpr' style='border: 1px solid #ffffff;'>
        <div class='titleLPR'><div class='txtTitleLpr'>Lecturas</div><br></div>
        <div class='valLPR' style='background: ${(activo == 1) ? severity_colors[severity] : 'rgba(20, 20, 20, 0.904)'}'><div class='txtLpr' style='color: ${((severity != 0) ? 'black !important' : 'lime')}' >${(activo == 1) ? val : ''}</div><br><br></div>
            </div>`)
          .addTo(lprData.map);
      });
    }



  }

  try {
    return (
      <>
        {
          (true) ?
            <>
              <div className='contMonitorMovil shell'>

                {/* <div className="topbar">
                  <div className="tb-brand">
                    <div className="tb-logo"><img src="/logo192.png" alt="logo" style={{ width: '100%', height: '100%' }} /></div>
                    <div className="tb-name">NetWatch</div>
                    <div className="tb-sep">•</div>
                    <div className="tb-sub">Monitoring Dashboard</div>
                    <div className="tb-pill">v3.0</div>
                  </div>
                </div> */}

                <RightQuadrant setDemoRelaciones={setDemoRelaciones} dataTec={dataTec} setDataTec={setDataTec} languaje={languaje} mode={mode} loaderMap={loaderMap} dataCriticalities={dataCriticalities} dataAgencies={dataAgencies} search_exceptions={search_exceptions} dataExceptions={dataExceptions} dataExceptionsCity={dataExceptionsCity} setDevices={setDevices} userPermissions={userPermissions} downs_list={downs_list} capas={capas} setCapas={setCapas} metricaSelected={metricaSelected} setMetricaSelected={setMetricaSelected} ubiActual={ubiActual} setUbiActual={setUbiActual} server={server} setRfid={setRfid} search_rfid={search_rfid} setLpr={setLpr} search_lpr={search_lpr} search_switches={search_switches} search_devices={search_devices} markersWOR={markersWOR} search_downs={search_downs} downs={downs} search_problems={search_problems} token={token_item} ubicacion={ubicacion} markers={markers} dataHosts={devices} setUbicacion={setUbicacion} />

                <div className="top-left-row">
                  <div className="panel-filtros">
                    <div className="panel-hdr expanded" onClick={() => {
                      const el = document.getElementById('panel-body-filtros');
                      const chev = document.getElementById('panel-chev-filtros');
                      if (el) { el.classList.toggle('hidden'); }
                      if (chev) { chev.classList.toggle('open'); }
                    }}>
                      <div className="panel-hdr-left">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                        <div className="panel-hdr-txt">Filtros</div>
                      </div>
                      <div className="chev open" id="panel-chev-filtros">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                      </div>
                    </div>
                    <div className="panel-body" id="panel-body-filtros">
                      {loaderMap ? '' : <SearchHost languaje={languaje} mode={mode} mapAux={mapAux} setmapAux={setmapAux} setExceptData={setExceptData} ubiActual={ubiActual} downs_list={downs_list} exceptions_list={exceptions_list} devices={devices} markersWOR={markersWOR}></SearchHost>}
                      <div id="filtros-container"></div>
                    </div>
                  </div>
                  {allTrue ? <ShowLayers languaje={languaje} mode={mode} dataCriticalities={dataCriticalities} dataAgencies={dataAgencies} exceptData={exceptData} exceptions={exceptions} showPopups={showPopups} setPopups={setPopups} setShowPopups={setShowPopups} capas={capas} setCapas={setCapas} mapAux={mapAux} setmapAux={setmapAux}></ShowLayers> : null}
                </div>

                <div className="map-full">
                  {loaderMap ? <LoadData languaje={languaje} mode={mode} /> : (internalError ? <InternalError /> : (
                    allTrue ? (mode == "1" ? <MapBox dataCriticalities={dataCriticalities} dataAgencies={dataAgencies} setExceptData={setExceptData} setPopups={setPopups} setShowPopups={setShowPopups} exceptions={exceptions} capas={capas} setCapas={setCapas} mapAux={mapAux} setmapAux={setmapAux} search_rfid={search_rfid} search_lpr={search_lpr} actualizar_lpr={actualizar_lpr} actualizar_rfi={actualizar_rfi} global_latitude={global_latitude} global_longitud={global_longitud} global_zoom={global_zoom} devices={devices} markers={markers} markersWOR={markersWOR} lines={lines} downs={downs} towers={towers} rfid={rfid} lpr={lpr} ubicacion={ubicacion} switches={switches} switchesFO={switchesFO} switchesMO={switchesMO} handleMarkerClick={handleMarkerClick} /> : <MapboxMapNew languaje={languaje} dataCriticalities={dataCriticalities} dataAgencies={dataAgencies} setExceptData={setExceptData} setPopups={setPopups} setShowPopups={setShowPopups} exceptions={exceptions} capas={capas} setCapas={setCapas} mapAux={mapAux} setmapAux={setmapAux} search_rfid={search_rfid} search_lpr={search_lpr} actualizar_lpr={actualizar_lpr} actualizar_rfi={actualizar_rfi} global_latitude={global_latitude} global_longitud={global_longitud} global_zoom={global_zoom} devices={devices} markers={markers} markersWOR={markersWOR} markersUnknown={markersUnknown} lines={lines} downs={downs} towers={towers} rfid={rfid} lpr={lpr} ubicacion={ubicacion} switches={switches} switchesFO={switchesFO} switchesMO={switchesMO} handleMarkerClick={handleMarkerClick} />) : null
                  ))}
                </div>

                <div style={{ position: 'absolute', top: '15%', right: '5%', maxHeight: '500px', overflow: 'auto', width: '275px', zIndex: 15 }}>
                  {ubiActual.dispId == 12 ? <PanelCorrelaciones startDemoAnimation={startDemoAnimation} setCapas={setCapas} capas={capas} languaje={languaje} CreateCisModalOpen={CreateCisModalOpen} mode={mode} hostsDisponibles={devices.data.hosts || []} demoRelaciones={demoRelaciones} setDemoRelaciones={setDemoRelaciones} mapAux={mapAux} setmapAux={setmapAux}></PanelCorrelaciones> : null}
                  {ubiActual.dispId != -1 ? <PanelExcepcion setCapas={setCapas} capas={capas} languaje={languaje} CreateCisModalOpen={CreateCisModalOpen} mode={mode} hostsDisponibles={devices.data.hosts || []} demoExcepciones={demoExcepciones} setDemoExcepciones={setDemoExcepciones} mapAux={mapAux} setmapAux={setmapAux}></PanelExcepcion> : null}
                </div>

                <LeftQuadrant markersUnknown={markersUnknown} languaje={languaje} mode={mode} suveryId={suveryId} setSuveryId={setSuveryId} setImportModalOpen={setImportModalOpen} dataProblemsError={dataProblemsError} dataCriticalities={dataCriticalities} dataAgencies={dataAgencies} handleShowPopup={handleShowPopup} dataExceptions={dataExceptions} userPermissions={userPermissions} ubiActual={ubiActual} mapAux={mapAux} setmapAux={setmapAux} server={server} zoom={zoom} setZoom={setZoom} markersWOR={markersWOR} markers={markers} token={token_item} setLatitudes={setLatitudes} setLongitudes={setLongitudes} setLocations={setLocations} longitudes={longitudes} locations={locations} search_problems={search_problems} ubicacion={ubicacion} dataHosts={devices} setUbicacion={setUbicacion} dataProblems={dataProblems} setDataProblems={setDataProblems} severityProblms={severityProblms} setSeverityProblms={setSeverityProblms} />

                <InfoMarker handleShowPopup={handleShowPopup} suveryId={suveryId} setSuveryId={setSuveryId} setImportModalOpen={setImportModalOpen} languaje={languaje} dataCriticalities={dataCriticalities} dataAgencies={dataAgencies} mode={mode} downs_list={downs_list} userPermissions={userPermissions} source={'Monitoreo'} mapAux={mapAux} setmapAux={setmapAux} search_problems={search_problems} devices={devices} server={server} isOpen={infoMarkerOpen} data={infoMarker} closeInfoMarker={closeInfoMarker} ubiActual={ubiActual} />
              </div>
            </> : <>
              {/* <div className='contMainError'>
                      <div className='contTitleErrorMsg'>
                          OCURRIO UN ERROR!!!
                      </div>
                      <div className={'contMainErrorMsg'+mode}>
                          Ha ocurrido un error al cargar los datos del sistema.
                          Favor de reportarlo.
                      </div>
                      <div className='contDetailErrorMsg'>
                          
                      </div>
                  </div> */}
              <div className='contMainError'>
                <div className='contTitleErrorMsg'>
                  {capitalizeFirstLetter(lang[languaje]['unMomento'])}...
                </div>
                <div className={'contMainErrorMsg' + mode}>
                  {capitalizeFirstLetter(lang[languaje]['msgLoadingLayers'])}.
                </div>
                <div className='contDetailErrorMsg'>
                  {
                    Object.values(renderCapas).map((element, index) => (
                      <div className='RowInfoErrorMsg'>
                        <div className={'CellTxtErrorMsg' + mode}>
                          {capasList[index] + ' --------> '}
                        </div>
                        <div className='CellValErrorMsg' style={{ color: (element) ? 'lime' : 'red' }}>
                          {(element) ? 'OK' : '----'}
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </>
        }


        <Modal
          isOpen={ImportModalOpen}
          // isOpen={false}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closeImportModal}
          style={CreateCisModalStyles}
          contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalResponseEncuesta

            server={server}
            suveryId={suveryId}
            closCreateCisModal={closeImportModal}
            languaje={languaje}
            mode={mode}
            handleShowPopup={handleShowPopup}
          ></ModalResponseEncuesta>
        </Modal>
        {/* <Modal
      isOpen={CreateCisModalOpen}
      // isOpen={false}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closCreateCisModal}
      style={CreateCorrModalStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
    >
    <ModalAddCorrelation
    devices={devices}
    server={server}
    // editActive={editActive}
    // setEditActive={setEditActive}
    // dataCis={dataCis}
    setData={setData}
    loading={loading}
    setLoading={setLoading}
    setError={setError}
    // dataUsers={dataUsers}
    dataHosts={devices.data.hosts}
    // setRegisterIsValid={setRegisterIsValid}
    closeAddHostModal={closCreateCisModal}
    // groupSelected={groupSelected}
    languaje={languaje}
    mode={mode}
    demoRelaciones={demoRelaciones}
    setDemoRelaciones={setDemoRelaciones}
    // setSearchTerm={setSearchTerm}
    // handleShowPopup={handleShowPopup}
    // search_problems={buscar_cis}
    // event={groupSelected}
  ></ModalAddCorrelation>
  </Modal> */}
      </>


    )
  } catch (error) {
    return (
      <InternalError />
    )
  }
}

export default Monitoreo